/**
* @preserve HTML5 Shiv 3.7.3 | @afarkas @jdalton @jon_neal @rem | MIT/GPL2 Licensed
*/
!function(a,b){function c(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function d(){var a=t.elements;return"string"==typeof a?a.split(" "):a}function e(a,b){var c=t.elements;"string"!=typeof c&&(c=c.join(" ")),"string"!=typeof a&&(a=a.join(" ")),t.elements=c+" "+a,j(b)}function f(a){var b=s[a[q]];return b||(b={},r++,a[q]=r,s[r]=b),b}function g(a,c,d){if(c||(c=b),l)return c.createElement(a);d||(d=f(c));var e;return e=d.cache[a]?d.cache[a].cloneNode():p.test(a)?(d.cache[a]=d.createElem(a)).cloneNode():d.createElem(a),!e.canHaveChildren||o.test(a)||e.tagUrn?e:d.frag.appendChild(e)}function h(a,c){if(a||(a=b),l)return a.createDocumentFragment();c=c||f(a);for(var e=c.frag.cloneNode(),g=0,h=d(),i=h.length;i>g;g++)e.createElement(h[g]);return e}function i(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return t.shivMethods?g(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+d().join().replace(/[\w\-:]+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(t,b.frag)}function j(a){a||(a=b);var d=f(a);return!t.shivCSS||k||d.hasCSS||(d.hasCSS=!!c(a,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),l||i(a,d),a}var k,l,m="3.7.3-pre",n=a.html5||{},o=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,p=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,q="_html5shiv",r=0,s={};!function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",k="hidden"in a,l=1==a.childNodes.length||function(){b.createElement("a");var a=b.createDocumentFragment();return"undefined"==typeof a.cloneNode||"undefined"==typeof a.createDocumentFragment||"undefined"==typeof a.createElement}()}catch(c){k=!0,l=!0}}();var t={elements:n.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:m,shivCSS:n.shivCSS!==!1,supportsUnknownElements:l,shivMethods:n.shivMethods!==!1,type:"default",shivDocument:j,createElement:g,createDocumentFragment:h,addElements:e};a.html5=t,j(b),"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:this,document);
/*!
 * clipboard.js v1.5.12
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.Clipboard=t()}}(function(){var t,e,n;return function t(e,n,o){function i(a,c){if(!n[a]){if(!e[a]){var s="function"==typeof require&&require;if(!c&&s)return s(a,!0);if(r)return r(a,!0);var l=new Error("Cannot find module '"+a+"'");throw l.code="MODULE_NOT_FOUND",l}var u=n[a]={exports:{}};e[a][0].call(u.exports,function(t){var n=e[a][1][t];return i(n?n:t)},u,u.exports,t,e,n,o)}return n[a].exports}for(var r="function"==typeof require&&require,a=0;a<o.length;a++)i(o[a]);return i}({1:[function(t,e,n){var o=t("matches-selector");e.exports=function(t,e,n){for(var i=n?t:t.parentNode;i&&i!==document;){if(o(i,e))return i;i=i.parentNode}}},{"matches-selector":5}],2:[function(t,e,n){function o(t,e,n,o,r){var a=i.apply(this,arguments);return t.addEventListener(n,a,r),{destroy:function(){t.removeEventListener(n,a,r)}}}function i(t,e,n,o){return function(n){n.delegateTarget=r(n.target,e,!0),n.delegateTarget&&o.call(t,n)}}var r=t("closest");e.exports=o},{closest:1}],3:[function(t,e,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){var e=Object.prototype.toString.call(t);return"[object Function]"===e}},{}],4:[function(t,e,n){function o(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!c.string(e))throw new TypeError("Second argument must be a String");if(!c.fn(n))throw new TypeError("Third argument must be a Function");if(c.node(t))return i(t,e,n);if(c.nodeList(t))return r(t,e,n);if(c.string(t))return a(t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")}function i(t,e,n){return t.addEventListener(e,n),{destroy:function(){t.removeEventListener(e,n)}}}function r(t,e,n){return Array.prototype.forEach.call(t,function(t){t.addEventListener(e,n)}),{destroy:function(){Array.prototype.forEach.call(t,function(t){t.removeEventListener(e,n)})}}}function a(t,e,n){return s(document.body,t,e,n)}var c=t("./is"),s=t("delegate");e.exports=o},{"./is":3,delegate:2}],5:[function(t,e,n){function o(t,e){if(r)return r.call(t,e);for(var n=t.parentNode.querySelectorAll(e),o=0;o<n.length;++o)if(n[o]==t)return!0;return!1}var i=Element.prototype,r=i.matchesSelector||i.webkitMatchesSelector||i.mozMatchesSelector||i.msMatchesSelector||i.oMatchesSelector;e.exports=o},{}],6:[function(t,e,n){function o(t){var e;if("INPUT"===t.nodeName||"TEXTAREA"===t.nodeName)t.focus(),t.setSelectionRange(0,t.value.length),e=t.value;else{t.hasAttribute("contenteditable")&&t.focus();var n=window.getSelection(),o=document.createRange();o.selectNodeContents(t),n.removeAllRanges(),n.addRange(o),e=n.toString()}return e}e.exports=o},{}],7:[function(t,e,n){function o(){}o.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){function o(){i.off(t,o),e.apply(n,arguments)}var i=this;return o._=e,this.on(t,o,n)},emit:function(t){var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,i=n.length;for(o;i>o;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],i=[];if(o&&e)for(var r=0,a=o.length;a>r;r++)o[r].fn!==e&&o[r].fn._!==e&&i.push(o[r]);return i.length?n[t]=i:delete n[t],this}},e.exports=o},{}],8:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","select"],r);else if("undefined"!=typeof o)r(n,e("select"));else{var a={exports:{}};r(a,i.select),i.clipboardAction=a.exports}}(this,function(t,e){"use strict";function n(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var i=n(e),r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol?"symbol":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),c=function(){function t(e){o(this,t),this.resolveOptions(e),this.initSelection()}return t.prototype.resolveOptions=function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.action=e.action,this.emitter=e.emitter,this.target=e.target,this.text=e.text,this.trigger=e.trigger,this.selectedText=""},t.prototype.initSelection=function t(){this.text?this.selectFake():this.target&&this.selectTarget()},t.prototype.selectFake=function t(){var e=this,n="rtl"==document.documentElement.getAttribute("dir");this.removeFake(),this.fakeHandlerCallback=function(){return e.removeFake()},this.fakeHandler=document.body.addEventListener("click",this.fakeHandlerCallback)||!0,this.fakeElem=document.createElement("textarea"),this.fakeElem.style.fontSize="12pt",this.fakeElem.style.border="0",this.fakeElem.style.padding="0",this.fakeElem.style.margin="0",this.fakeElem.style.position="absolute",this.fakeElem.style[n?"right":"left"]="-9999px",this.fakeElem.style.top=(window.pageYOffset||document.documentElement.scrollTop)+"px",this.fakeElem.setAttribute("readonly",""),this.fakeElem.value=this.text,document.body.appendChild(this.fakeElem),this.selectedText=(0,i.default)(this.fakeElem),this.copyText()},t.prototype.removeFake=function t(){this.fakeHandler&&(document.body.removeEventListener("click",this.fakeHandlerCallback),this.fakeHandler=null,this.fakeHandlerCallback=null),this.fakeElem&&(document.body.removeChild(this.fakeElem),this.fakeElem=null)},t.prototype.selectTarget=function t(){this.selectedText=(0,i.default)(this.target),this.copyText()},t.prototype.copyText=function t(){var e=void 0;try{e=document.execCommand(this.action)}catch(n){e=!1}this.handleResult(e)},t.prototype.handleResult=function t(e){e?this.emitter.emit("success",{action:this.action,text:this.selectedText,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)}):this.emitter.emit("error",{action:this.action,trigger:this.trigger,clearSelection:this.clearSelection.bind(this)})},t.prototype.clearSelection=function t(){this.target&&this.target.blur(),window.getSelection().removeAllRanges()},t.prototype.destroy=function t(){this.removeFake()},a(t,[{key:"action",set:function t(){var e=arguments.length<=0||void 0===arguments[0]?"copy":arguments[0];if(this._action=e,"copy"!==this._action&&"cut"!==this._action)throw new Error('Invalid "action" value, use either "copy" or "cut"')},get:function t(){return this._action}},{key:"target",set:function t(e){if(void 0!==e){if(!e||"object"!==("undefined"==typeof e?"undefined":r(e))||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===this.action&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===this.action&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');this._target=e}},get:function t(){return this._target}}]),t}();t.exports=c})},{select:6}],9:[function(e,n,o){!function(i,r){if("function"==typeof t&&t.amd)t(["module","./clipboard-action","tiny-emitter","good-listener"],r);else if("undefined"!=typeof o)r(n,e("./clipboard-action"),e("tiny-emitter"),e("good-listener"));else{var a={exports:{}};r(a,i.clipboardAction,i.tinyEmitter,i.goodListener),i.clipboard=a.exports}}(this,function(t,e,n,o){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function a(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function c(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){var n="data-clipboard-"+t;if(e.hasAttribute(n))return e.getAttribute(n)}var l=i(e),u=i(n),f=i(o),d=function(t){function e(n,o){r(this,e);var i=a(this,t.call(this));return i.resolveOptions(o),i.listenClick(n),i}return c(e,t),e.prototype.resolveOptions=function t(){var e=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.action="function"==typeof e.action?e.action:this.defaultAction,this.target="function"==typeof e.target?e.target:this.defaultTarget,this.text="function"==typeof e.text?e.text:this.defaultText},e.prototype.listenClick=function t(e){var n=this;this.listener=(0,f.default)(e,"click",function(t){return n.onClick(t)})},e.prototype.onClick=function t(e){var n=e.delegateTarget||e.currentTarget;this.clipboardAction&&(this.clipboardAction=null),this.clipboardAction=new l.default({action:this.action(n),target:this.target(n),text:this.text(n),trigger:n,emitter:this})},e.prototype.defaultAction=function t(e){return s("action",e)},e.prototype.defaultTarget=function t(e){var n=s("target",e);return n?document.querySelector(n):void 0},e.prototype.defaultText=function t(e){return s("text",e)},e.prototype.destroy=function t(){this.listener.destroy(),this.clipboardAction&&(this.clipboardAction.destroy(),this.clipboardAction=null)},e}(u.default);t.exports=d})},{"./clipboard-action":8,"good-listener":4,"tiny-emitter":7}]},{},[9])(9)});

/**
 * Refactored global Javascript for use on all asana.com pages
 * Custom JS should be loaded after this file - and preferably after the DOM
 * This file must load before the <body> - let"s keep it lightweight ;-)
 *
 * the "//= include" is a directive to concat the js files with the js below
 * see https://www.npmjs.com/package/gulp-include
 */

//
// **Bugsnag.js** is the official JavaScript notifier for
// [Bugsnag](https://bugsnag.com).
//
// Bugsnag gives you instant notification of errors and
// exceptions in your website's JavaScript code.
//
// Bugsnag.js is incredibly small, and has no external dependencies (not even
// jQuery!) so you can safely use it on any website.
//

// The `Bugsnag` object is the only globally exported variable
(function (window, old) {
  var self = {},
    lastEvent,
    lastScript,
    previousNotification,
    shouldCatch = true,
    ignoreOnError = 0,

  // We've seen cases where individual clients can infinite loop sending us errors
  // (in some cases 10,000+ errors per page). This limit is at the point where
  // you've probably learned everything useful there is to debug the problem,
  // and we're happy to under-estimate the count to save the client (and Bugsnag's) resources.
    eventsRemaining = 10;

  // #### Bugsnag.noConflict
  //
  // This is obsolete with UMD, as we cannot assume the global scope is polluted with
  // the Bugsnag object anyway. In this case, it's up to the host Javascript file to
  // correctly utilise this functionality.
  //
  // Maybe it's worth removing all together, if we're loading via any UMD method.
  self.noConflict = function() {
    window.Bugsnag = old;
    return self;
  };

  // ### Bugsnag.refresh
  //
  // Resets the Bugsnag rate limit. If you have a large single-page app, you may
  // wish to call this in your router to avoid exception reports being thrown
  // away.
  //
  // By default Bugsnag aggressively limits the number of exception reports from
  // one page load. This protects both the client's browser and our servers in
  // cases where exceptions are thrown in tight loops or scroll handlers.
  self.refresh = function() {
    eventsRemaining = 10;
  };

  //
  // ### Manual error notification (public methods)
  //

  // #### Bugsnag.notifyException
  //
  // Notify Bugsnag about a given `exception`, typically that you've caught
  // with a `try/catch` statement or that you've generated yourself.
  //
  // It's almost always better to let an exception bubble rather than catching
  // it, as that gives more consistent behaviour across browsers. Consider
  // re-throwing instead of calling .notifyException.
  //
  // Since most JavaScript exceptions use the `Error` class, we also allow
  // you to provide a custom error name when calling `notifyException`.
  //
  // The default value is "warning" and "error" and "info" are also supported by the
  // backend, all other values cause the notification to be dropped; and you
  // will not see it in your dashboard.
  self.notifyException = function (exception, name, metaData, severity) {
    if (name && typeof name !== "string") {
      metaData = name;
      name = undefined;
    }
    if (!metaData) {
      metaData = {};
    }
    addScriptToMetaData(metaData);

    sendToBugsnag({
      name: name || exception.name,
      message: exception.message || exception.description,
      stacktrace: stacktraceFromException(exception) || generateStacktrace(),
      file: exception.fileName || exception.sourceURL,
      lineNumber: exception.lineNumber || exception.line,
      columnNumber: exception.columnNumber ? exception.columnNumber + 1 : undefined,
      severity: severity || "warning"
    }, metaData);
  };

  // #### Bugsnag.notify
  //
  // Notify Bugsnag about an error by passing in a `name` and `message`,
  // without requiring an exception.
  self.notify = function (name, message, metaData, severity) {
    sendToBugsnag({
      name: name,
      message: message,
      stacktrace: generateStacktrace(),
      // These are defaults so that 'bugsnag.notify()' calls show up in old IE,
      // newer browsers get a legit stacktrace from generateStacktrace().
      file: window.location.toString(),
      lineNumber: 1,
      severity: severity || "warning"
    }, metaData);
  };

  // Return a function acts like the given function, but reports
  // any exceptions to Bugsnag before re-throwing them.
  //
  // This is not a public function because it can only be used if
  // the exception is not caught after being thrown out of this function.
  //
  // If you call wrap twice on the same function, it'll give you back the
  // same wrapped function. This lets removeEventListener to continue to
  // work.
  function wrap(_super, options) {
    try {
      if (typeof _super !== "function") {
        return _super;
      }
      if (!_super.bugsnag) {
        var currentScript = getCurrentScript();
        _super.bugsnag = function (event) {
          if (options && options.eventHandler) {
            lastEvent = event;
          }
          lastScript = currentScript;

          // We set shouldCatch to false on IE < 10 because catching the error ruins the file/line as reported in window.onerror,
          // We set shouldCatch to false on Chrome/Safari because it interferes with "break on unhandled exception"
          // All other browsers need shouldCatch to be true, as they don't pass the exception object to window.onerror
          if (shouldCatch) {
            try {
              return _super.apply(this, arguments);
            } catch (e) {
              // We do this rather than stashing treating the error like lastEvent
              // because in FF 26 onerror is not called for synthesized event handlers.
              if (getSetting("autoNotify", true)) {
                self.notifyException(e, null, null, "error");
                ignoreNextOnError();
              }
              throw e;
            } finally {
              lastScript = null;
            }
          } else {
            var ret = _super.apply(this, arguments);
            // in case of error, this is set to null in window.onerror
            lastScript = null;
            return ret;
          }
        };
        _super.bugsnag.bugsnag = _super.bugsnag;
      }
      return _super.bugsnag;

      // This can happen if _super is not a normal javascript function.
      // For example, see https://github.com/bugsnag/bugsnag-js/issues/28
    } catch (e) {
      return _super;
    }
  }

  //
  // ### Script tag tracking
  //

  // To emulate document.currentScript we use document.scripts.last.
  // This only works while synchronous scripts are running, so we track
  // that here.
  var synchronousScriptsRunning = document.readyState !== "complete";
  function loadCompleted() {
    synchronousScriptsRunning = false;
  }

  // from jQuery. We don't have quite such tight bounds as they do if
  // we end up on the window.onload event as we don't try and hack
  // the .scrollLeft() fix in because it doesn't work in frames so
  // we'd need these fallbacks anyway.
  // The worst that can happen is we group an event handler that fires
  // before us into the last script tag.
  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", loadCompleted, true);
    window.addEventListener("load", loadCompleted, true);
  } else {
    window.attachEvent("onload", loadCompleted);
  }

  function getCurrentScript() {
    var script = document.currentScript || lastScript;

    if (!script && synchronousScriptsRunning) {
      var scripts = document.scripts || document.getElementsByTagName("script");
      script = scripts[scripts.length - 1];
    }

    return script;
  }

  function addScriptToMetaData(metaData) {
    var script = getCurrentScript();

    if (script) {
      metaData.script = {
        src: script.src,
        content: getSetting("inlineScript", true) ? script.innerHTML : ""
      };
    }
  }

  //
  // ### Helpers & Setup
  //

  // Compile regular expressions upfront.
  var API_KEY_REGEX = /^[0-9a-f]{32}$/i;
  var FUNCTION_REGEX = /function\s*([\w\-$]+)?\s*\(/i;

  // Set up default notifier settings.
  var DEFAULT_BASE_ENDPOINT = "https://notify.bugsnag.com/";
  var DEFAULT_NOTIFIER_ENDPOINT = DEFAULT_BASE_ENDPOINT + "js";
  var NOTIFIER_VERSION = "2.4.8";

  // Keep a reference to the currently executing script in the DOM.
  // We'll use this later to extract settings from attributes.
  var scripts = document.getElementsByTagName("script");
  var thisScript = scripts[scripts.length - 1];

  // Simple logging function that wraps `console.log` if available.
  // This is useful for warning about configuration issues
  // eg. forgetting to set an API key.
  function log(msg) {
    var disableLog = getSetting("disableLog");

    var console = window.console;
    if (console !== undefined && console.log !== undefined && !disableLog) {
      console.log("[Bugsnag] " + msg);
    }
  }

  // Deeply serialize an object into a query string. We use the PHP-style
  // nested object syntax, `nested[keys]=val`, to support heirachical
  // objects. Similar to jQuery's `$.param` method.
  function serialize(obj, prefix, depth) {
    if (depth >= 5) {
      return encodeURIComponent(prefix) + "=[RECURSIVE]";
    }
    depth = depth + 1 || 1;

    try {
      if (window.Node && obj instanceof window.Node) {
        return encodeURIComponent(prefix) + "=" + encodeURIComponent(targetToString(obj));
      }

      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p) && p != null && obj[p] != null) {
          var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
          str.push(typeof v === "object" ? serialize(v, k, depth) : encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
      }
      return str.join("&");
    } catch (e) {
      return encodeURIComponent(prefix) + "=" + encodeURIComponent("" + e);
    }
  }

  // Deep-merge the `source` object into the `target` object and return
  // the `target`. Properties in source that will overwrite those in target.
  // Similar to jQuery's `$.extend` method.
  function merge(target, source) {
    if (source == null) {
      return target;
    }

    target = target || {};
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        try {
          if (source[key].constructor === Object) {
            target[key] = merge(target[key], source[key]);
          } else {
            target[key] = source[key];
          }
        } catch (e) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }

  // Make a HTTP request with given `url` and `params` object.
  // For maximum browser compatibility and cross-domain support, requests are
  // made by creating a temporary JavaScript `Image` object.
  function request(url, params) {
    url += "?" + serialize(params) + "&ct=img&cb=" + new Date().getTime();
    if (typeof BUGSNAG_TESTING !== "undefined" && self.testRequest) {
      self.testRequest(url, params);
    } else {
      var img = new Image();
      img.src = url;
    }
  }

  // Extract all `data-*` attributes from a DOM element and return them as an
  // object. This is used to allow Bugsnag settings to be set via attributes
  // on the `script` tag, eg. `<script data-apikey="xyz">`.
  // Similar to jQuery's `$(el).data()` method.
  function getData(node) {
    var dataAttrs = {};
    var dataRegex = /^data\-([\w\-]+)$/;

    // If the node doesn't exist due to being loaded as a commonjs module,
    // then return an empty object and fallback to self[].
    if (node) {
      var attrs = node.attributes;
      for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (dataRegex.test(attr.nodeName)) {
          var key = attr.nodeName.match(dataRegex)[1];
          dataAttrs[key] = attr.value || attr.nodeValue;
        }
      }
    }

    return dataAttrs;
  }

  // Get configuration settings from either `self` (the `Bugsnag` object)
  // or `data` (the `data-*` attributes).
  var data;
  function getSetting(name, fallback) {
    data = data || getData(thisScript);
    var setting = self[name] !== undefined ? self[name] : data[name.toLowerCase()];
    if (setting === "false") {
      setting = false;
    }
    return setting !== undefined ? setting : fallback;
  }

  // Validate a Bugsnag API key exists and is of the correct format.
  function validateApiKey(apiKey) {
    if (!apiKey || !apiKey.match(API_KEY_REGEX)) {
      log("Invalid API key '" + apiKey + "'");
      return false;
    }

    return true;
  }

  // Send an error to Bugsnag.
  function sendToBugsnag(details, metaData) {
    // Validate the configured API key.
    var apiKey = getSetting("apiKey");
    if (!validateApiKey(apiKey) || !eventsRemaining) {
      return;
    }
    eventsRemaining -= 1;

    // Check if we should notify for this release stage.
    var releaseStage = getSetting("releaseStage", "production");
    var notifyReleaseStages = getSetting("notifyReleaseStages");
    if (notifyReleaseStages) {
      var shouldNotify = false;
      for (var i = 0; i < notifyReleaseStages.length; i++) {
        if (releaseStage === notifyReleaseStages[i]) {
          shouldNotify = true;
          break;
        }
      }

      if (!shouldNotify) {
        return;
      }
    }

    // Don't send multiple copies of the same error.
    // This fixes a problem when a client goes into an infinite loop,
    // and starts wasting all their bandwidth sending messages to bugsnag.
    var deduplicate = [details.name, details.message, details.stacktrace].join("|");
    if (deduplicate === previousNotification) {
      return;
    } else {
      previousNotification = deduplicate;
    }

    if (lastEvent) {
      metaData = metaData || {};
      metaData["Last Event"] = eventToMetaData(lastEvent);
    }

    // Build the request payload by combining error information with other data
    // such as user-agent and locale, `metaData` and settings.
    var payload = {
      notifierVersion: NOTIFIER_VERSION,

      apiKey: apiKey,
      projectRoot: getSetting("projectRoot") || window.location.protocol + "//" + window.location.host,
      context: getSetting("context") || window.location.pathname,
      userId: getSetting("userId"), // Deprecated, remove in v3
      user: getSetting("user"),
      metaData: merge(merge({}, getSetting("metaData")), metaData),
      releaseStage: releaseStage,
      appVersion: getSetting("appVersion"),

      url: window.location.href,
      userAgent: navigator.userAgent,
      language: navigator.language || navigator.userLanguage,

      severity: details.severity,

      name: details.name,
      message: details.message,
      stacktrace: details.stacktrace,
      file: details.file,
      lineNumber: details.lineNumber,
      columnNumber: details.columnNumber,
      payloadVersion: "2"
    };

    // Run any `beforeNotify` function
    var beforeNotify = self.beforeNotify;
    if (typeof(beforeNotify) === "function") {
      var retVal = beforeNotify(payload, payload.metaData);
      if (retVal === false) {
        return;
      }
    }

    if (payload.lineNumber === 0 && (/Script error\.?/).test(payload.message)) {
      return log("Ignoring cross-domain script error. See https://bugsnag.com/docs/notifiers/js/cors");
    }

    // Make the HTTP request
    request(getSetting("endpoint") || DEFAULT_NOTIFIER_ENDPOINT, payload);
  }

  // Generate a browser stacktrace (or approximation) from the current stack.
  // This is used to add a stacktrace to `Bugsnag.notify` calls, and to add a
  // stacktrace approximation where we can't get one from an exception.
  function generateStacktrace() {
    var generated, stacktrace;
    var MAX_FAKE_STACK_SIZE = 10;
    var ANONYMOUS_FUNCTION_PLACEHOLDER = "[anonymous]";

    // Try to generate a real stacktrace (most browsers, except IE9 and below).
    try {
      throw new Error("");
    } catch (exception) {
      generated = "<generated>\n";
      stacktrace = stacktraceFromException(exception);
    }

    // Otherwise, build a fake stacktrace from the list of method names by
    // looping through the list of functions that called this one (and skip
    // whoever called us).
    if (!stacktrace) {
      generated = "<generated-ie>\n";
      var functionStack = [];
      try {
        var curr = arguments.callee.caller.caller;
        while (curr && functionStack.length < MAX_FAKE_STACK_SIZE) {
          var fn = FUNCTION_REGEX.test(curr.toString()) ? RegExp.$1 || ANONYMOUS_FUNCTION_PLACEHOLDER : ANONYMOUS_FUNCTION_PLACEHOLDER;
          functionStack.push(fn);
          curr = curr.caller;
        }
      } catch (e) {
        log(e);
      }
      stacktrace = functionStack.join("\n");
    }

    // Tell the backend to ignore the first two lines in the stack-trace.
    // generateStacktrace() + window.onerror,
    // generateStacktrace() + notify,
    // generateStacktrace() + notifyException
    return generated + stacktrace;
  }

  // Get the stacktrace string from an exception
  function stacktraceFromException(exception) {
    return exception.stack || exception.backtrace || exception.stacktrace;
  }

  // Populate the event tab of meta-data.
  function eventToMetaData(event) {
    var tab = {
      millisecondsAgo: new Date() - event.timeStamp,
      type: event.type,
      which: event.which,
      target: targetToString(event.target)
    };

    return tab;
  }

  // Convert a DOM element into a string suitable for passing to Bugsnag.
  function targetToString(target) {
    if (target) {
      var attrs = target.attributes;

      if (attrs) {
        var ret = "<" + target.nodeName.toLowerCase();
        for (var i = 0; i < attrs.length; i++) {
          if (attrs[i].value && attrs[i].value.toString() != "null") {
            ret += " " + attrs[i].name + "=\"" + attrs[i].value + "\"";
          }
        }
        return ret + ">";
      } else {
        // e.g. #document
        return target.nodeName;
      }
    }
  }

  // If we've notified bugsnag of an exception in wrap, we don't want to
  // re-notify when it hits window.onerror after we re-throw it.
  function ignoreNextOnError() {
    ignoreOnError += 1;
    window.setTimeout(function () {
      ignoreOnError -= 1;
    });
  }

  // Disable catching on IE < 10 as it destroys stack-traces from generateStackTrace()
  if (!window.atob) {
    shouldCatch = false;

    // Disable catching on browsers that support HTML5 ErrorEvents properly.
    // This lets debug on unhandled exceptions work.
  } else if (window.ErrorEvent) {
    try {
      if (new window.ErrorEvent("test").colno === 0) {
        shouldCatch = false;
      }
    } catch(e){ }
  }


  //
  // ### Polyfilling
  //

  // Add a polyFill to an object
  function polyFill(obj, name, makeReplacement) {
    var original = obj[name];
    var replacement = makeReplacement(original);
    obj[name] = replacement;

    if (typeof BUGSNAG_TESTING !== "undefined" && window.undo) {
      window.undo.push(function () {
        obj[name] = original;
      });
    }
  }

  if (getSetting("autoNotify", true)) {
    //
    // ### Automatic error notification
    //
    // Attach to `window.onerror` events and notify Bugsnag when they happen.
    // These are mostly js compile/parse errors, but on some browsers all
    // "uncaught" exceptions will fire this event.
    //
    polyFill(window, "onerror", function (_super) {
      // Keep a reference to any existing `window.onerror` handler
      if (typeof BUGSNAG_TESTING !== "undefined") {
        self._onerror = _super;
      }

      return function bugsnag(message, url, lineNo, charNo, exception) {
        var shouldNotify = getSetting("autoNotify", true);
        var metaData = {};

        // IE 6+ support.
        if (!charNo && window.event) {
          charNo = window.event.errorCharacter;
        }

        addScriptToMetaData(metaData);
        lastScript = null;

        if (shouldNotify && !ignoreOnError) {

          sendToBugsnag({
            name: exception && exception.name || "window.onerror",
            message: message,
            file: url,
            lineNumber: lineNo,
            columnNumber: charNo,
            stacktrace: (exception && stacktraceFromException(exception)) || generateStacktrace(),
            severity: "error"
          }, metaData);
        }

        if (typeof BUGSNAG_TESTING !== "undefined") {
          _super = self._onerror;
        }

        // Fire the existing `window.onerror` handler, if one exists
        if (_super) {
          _super(message, url, lineNo, charNo, exception);
        }
      };
    });

    var hijackTimeFunc = function (_super) {
      // Note, we don't do `_super.call` because that doesn't work on IE 8,
      // luckily this is implicitly window so it just works everywhere.
      //
      // setTimout in all browsers except IE <9 allows additional parameters
      // to be passed, so in order to support these without resorting to call/apply
      // we need an extra layer of wrapping.
      return function (f, t) {
        if (typeof f === "function") {
          f = wrap(f);
          var args = Array.prototype.slice.call(arguments, 2);
          return _super(function () {
            f.apply(this, args);
          }, t);
        } else {
          return _super(f, t);
        }
      };
    };

    polyFill(window, "setTimeout", hijackTimeFunc);
    polyFill(window, "setInterval", hijackTimeFunc);

    if (window.requestAnimationFrame) {
      polyFill(window, "requestAnimationFrame", function (_super) {
        return function (callback) {
          return _super(wrap(callback));
        };
      });
    }

    if (window.setImmediate) {
      polyFill(window, "setImmediate", function (_super) {
        return function (f) {
          var args = Array.prototype.slice.call(arguments);
          args[0] = wrap(args[0]);
          return _super.apply(this, args);
        };
      });
    }

    // EventTarget is all that's required in modern chrome/opera
    // EventTarget + Window + ModalWindow is all that's required in modern FF (there are a few Moz prefixed ones that we're ignoring)
    // The rest is a collection of stuff for Safari and IE 11. (Again ignoring a few MS and WebKit prefixed things)
    "EventTarget Window Node ApplicationCache AudioTrackList ChannelMergerNode CryptoOperation EventSource FileReader HTMLUnknownElement IDBDatabase IDBRequest IDBTransaction KeyOperation MediaController MessagePort ModalWindow Notification SVGElementInstance Screen TextTrack TextTrackCue TextTrackList WebSocket WebSocketWorker Worker XMLHttpRequest XMLHttpRequestEventTarget XMLHttpRequestUpload".replace(/\w+/g, function (global) {
      var prototype = window[global] && window[global].prototype;
      if (prototype && prototype.hasOwnProperty && prototype.hasOwnProperty("addEventListener")) {
        polyFill(prototype, "addEventListener", function (_super) {
          return function (e, f, capture, secure) {
            // HTML lets event-handlers be objects with a handlEvent function,
            // we need to change f.handleEvent here, as self.wrap will ignore f.
            try {
              if (f && f.handleEvent) {
                f.handleEvent = wrap(f.handleEvent, {eventHandler: true});
              }
            } catch (err) {
              // When selenium is installed, we sometimes get 'Permission denied to access property "handleEvent"'
              // Because this catch is around Bugsnag library code, it won't catch any user errors
              log(err);
            }
            return _super.call(this, e, wrap(f, {eventHandler: true}), capture, secure);
          };
        });

        // We also need to hack removeEventListener so that you can remove any
        // event listeners.
        polyFill(prototype, "removeEventListener", function (_super) {
          return function (e, f, capture, secure) {
            _super.call(this, e, f, capture, secure);
            return _super.call(this, e, wrap(f), capture, secure);
          };
        });
      }
    });
  }

  window.Bugsnag = self;
  // If people are using a javascript loader, we should integrate with it.
  // We don't want to defer instrumenting their code with callbacks however,
  // so we slightly abuse the intent and continue with our plan of polyfilling
  // the browser whether or not they ever actually require the module.
  // This has the nice side-effect of continuing to work when people are using
  // AMD but loading Bugsnag via a CDN.
  // It has the not-so-nice side-effect of polluting the global namespace, but
  // you can easily call Bugsnag.noConflict() to fix that.
  if (typeof define === "function" && define.amd) {
    // AMD
    define([], function () {
      return self;
    });
  } else if (typeof module === "object" && typeof module.exports === "object") {
    // CommonJS/Browserify
    module.exports = self;
  }

})(window, window.Bugsnag);
/*
 * Copyright 2015 Small Batch, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */
/* Web Font Loader v1.5.18 - (c) Adobe Systems, Google. License: Apache 2.0 */
;(function(window,document,undefined){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function k(a,b,c){k=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return k.apply(null,arguments)}var n=Date.now||function(){return+new Date};function q(a,b){this.K=a;this.w=b||a;this.G=this.w.document}q.prototype.createElement=function(a,b,c){a=this.G.createElement(a);if(b)for(var d in b)b.hasOwnProperty(d)&&("style"==d?a.style.cssText=b[d]:a.setAttribute(d,b[d]));c&&a.appendChild(this.G.createTextNode(c));return a};function r(a,b,c){a=a.G.getElementsByTagName(b)[0];a||(a=document.documentElement);a&&a.lastChild&&a.insertBefore(c,a.lastChild)}function ca(a,b){function c(){a.G.body?b():setTimeout(c,0)}c()}
  function s(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function t(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
  function u(a){if("string"===typeof a.na)return a.na;var b=a.w.location.protocol;"about:"==b&&(b=a.K.location.protocol);return"https:"==b?"https:":"http:"}function v(a,b){var c=a.createElement("link",{rel:"stylesheet",href:b,media:"all"}),d=!1;c.onload=function(){d||(d=!0)};c.onerror=function(){d||(d=!0)};r(a,"head",c)}
  function w(a,b,c,d){var e=a.G.getElementsByTagName("head")[0];if(e){var f=a.createElement("script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);window.setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function x(a,b){this.Y=a;this.ga=b};function y(a,b,c,d){this.c=null!=a?a:null;this.g=null!=b?b:null;this.D=null!=c?c:null;this.e=null!=d?d:null}var da=/^([0-9]+)(?:[\._-]([0-9]+))?(?:[\._-]([0-9]+))?(?:[\._+-]?(.*))?$/;y.prototype.compare=function(a){return this.c>a.c||this.c===a.c&&this.g>a.g||this.c===a.c&&this.g===a.g&&this.D>a.D?1:this.c<a.c||this.c===a.c&&this.g<a.g||this.c===a.c&&this.g===a.g&&this.D<a.D?-1:0};y.prototype.toString=function(){return[this.c,this.g||"",this.D||"",this.e||""].join("")};
  function z(a){a=da.exec(a);var b=null,c=null,d=null,e=null;a&&(null!==a[1]&&a[1]&&(b=parseInt(a[1],10)),null!==a[2]&&a[2]&&(c=parseInt(a[2],10)),null!==a[3]&&a[3]&&(d=parseInt(a[3],10)),null!==a[4]&&a[4]&&(e=/^[0-9]+$/.test(a[4])?parseInt(a[4],10):a[4]));return new y(b,c,d,e)};function A(a,b,c,d,e,f,g,h){this.N=a;this.k=h}A.prototype.getName=function(){return this.N};function B(a){this.a=a}var ea=new A("Unknown",0,0,0,0,0,0,new x(!1,!1));
  B.prototype.parse=function(){var a;if(-1!=this.a.indexOf("MSIE")||-1!=this.a.indexOf("Trident/")){a=C(this);var b=z(D(this)),c=null,d=E(this.a,/Trident\/([\d\w\.]+)/,1),c=-1!=this.a.indexOf("MSIE")?z(E(this.a,/MSIE ([\d\w\.]+)/,1)):z(E(this.a,/rv:([\d\w\.]+)/,1));""!=d&&z(d);a=new A("MSIE",0,0,0,0,0,0,new x("Windows"==a&&6<=c.c||"Windows Phone"==a&&8<=b.c,!1))}else if(-1!=this.a.indexOf("Opera"))a:if(a=z(E(this.a,/Presto\/([\d\w\.]+)/,1)),z(D(this)),null!==a.c||z(E(this.a,/rv:([^\)]+)/,1)),-1!=this.a.indexOf("Opera Mini/"))a=
    z(E(this.a,/Opera Mini\/([\d\.]+)/,1)),a=new A("OperaMini",0,0,0,C(this),0,0,new x(!1,!1));else{if(-1!=this.a.indexOf("Version/")&&(a=z(E(this.a,/Version\/([\d\.]+)/,1)),null!==a.c)){a=new A("Opera",0,0,0,C(this),0,0,new x(10<=a.c,!1));break a}a=z(E(this.a,/Opera[\/ ]([\d\.]+)/,1));a=null!==a.c?new A("Opera",0,0,0,C(this),0,0,new x(10<=a.c,!1)):new A("Opera",0,0,0,C(this),0,0,new x(!1,!1))}else/OPR\/[\d.]+/.test(this.a)?a=F(this):/AppleWeb(K|k)it/.test(this.a)?a=F(this):-1!=this.a.indexOf("Gecko")?
    (a="Unknown",b=new y,z(D(this)),b=!1,-1!=this.a.indexOf("Firefox")?(a="Firefox",b=z(E(this.a,/Firefox\/([\d\w\.]+)/,1)),b=3<=b.c&&5<=b.g):-1!=this.a.indexOf("Mozilla")&&(a="Mozilla"),c=z(E(this.a,/rv:([^\)]+)/,1)),b||(b=1<c.c||1==c.c&&9<c.g||1==c.c&&9==c.g&&2<=c.D),a=new A(a,0,0,0,C(this),0,0,new x(b,!1))):a=ea;return a};
  function C(a){var b=E(a.a,/(iPod|iPad|iPhone|Android|Windows Phone|BB\d{2}|BlackBerry)/,1);if(""!=b)return/BB\d{2}/.test(b)&&(b="BlackBerry"),b;a=E(a.a,/(Linux|Mac_PowerPC|Macintosh|Windows|CrOS|PlayStation|CrKey)/,1);return""!=a?("Mac_PowerPC"==a?a="Macintosh":"PlayStation"==a&&(a="Linux"),a):"Unknown"}
  function D(a){var b=E(a.a,/(OS X|Windows NT|Android) ([^;)]+)/,2);if(b||(b=E(a.a,/Windows Phone( OS)? ([^;)]+)/,2))||(b=E(a.a,/(iPhone )?OS ([\d_]+)/,2)))return b;if(b=E(a.a,/(?:Linux|CrOS|CrKey) ([^;)]+)/,1))for(var b=b.split(/\s/),c=0;c<b.length;c+=1)if(/^[\d\._]+$/.test(b[c]))return b[c];return(a=E(a.a,/(BB\d{2}|BlackBerry).*?Version\/([^\s]*)/,2))?a:"Unknown"}
  function F(a){var b=C(a),c=z(D(a)),d=z(E(a.a,/AppleWeb(?:K|k)it\/([\d\.\+]+)/,1)),e="Unknown",f=new y,f="Unknown",g=!1;/OPR\/[\d.]+/.test(a.a)?e="Opera":-1!=a.a.indexOf("Chrome")||-1!=a.a.indexOf("CrMo")||-1!=a.a.indexOf("CriOS")?e="Chrome":/Silk\/\d/.test(a.a)?e="Silk":"BlackBerry"==b||"Android"==b?e="BuiltinBrowser":-1!=a.a.indexOf("PhantomJS")?e="PhantomJS":-1!=a.a.indexOf("Safari")?e="Safari":-1!=a.a.indexOf("AdobeAIR")?e="AdobeAIR":-1!=a.a.indexOf("PlayStation")&&(e="BuiltinBrowser");"BuiltinBrowser"==
    e?f="Unknown":"Silk"==e?f=E(a.a,/Silk\/([\d\._]+)/,1):"Chrome"==e?f=E(a.a,/(Chrome|CrMo|CriOS)\/([\d\.]+)/,2):-1!=a.a.indexOf("Version/")?f=E(a.a,/Version\/([\d\.\w]+)/,1):"AdobeAIR"==e?f=E(a.a,/AdobeAIR\/([\d\.]+)/,1):"Opera"==e?f=E(a.a,/OPR\/([\d.]+)/,1):"PhantomJS"==e&&(f=E(a.a,/PhantomJS\/([\d.]+)/,1));f=z(f);g="AdobeAIR"==e?2<f.c||2==f.c&&5<=f.g:"BlackBerry"==b?10<=c.c:"Android"==b?2<c.c||2==c.c&&1<c.g:526<=d.c||525<=d.c&&13<=d.g;return new A(e,0,0,0,0,0,0,new x(g,536>d.c||536==d.c&&11>d.g))}
  function E(a,b,c){return(a=a.match(b))&&a[c]?a[c]:""};function G(a){this.ma=a||"-"}G.prototype.e=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.ma)};function H(a,b){this.N=a;this.Z=4;this.O="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.O=c[1],this.Z=parseInt(c[2],10))}H.prototype.getName=function(){return this.N};function I(a){return a.O+a.Z}function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.d=a;this.q=a.w.document.documentElement;this.Q=b;this.j="wf";this.h=new G("-");this.ha=!1!==b.events;this.F=!1!==b.classes}function J(a){if(a.F){var b=t(a.q,a.h.e(a.j,"active")),c=[],d=[a.h.e(a.j,"loading")];b||c.push(a.h.e(a.j,"inactive"));s(a.q,c,d)}K(a,"inactive")}function K(a,b,c){if(a.ha&&a.Q[b])if(c)a.Q[b](c.getName(),I(c));else a.Q[b]()};function ia(){this.C={}};function L(a,b){this.d=a;this.I=b;this.o=this.d.createElement("span",{"aria-hidden":"true"},this.I)}
  function M(a,b){var c=a.o,d;d=[];for(var e=b.N.split(/,\s*/),f=0;f<e.length;f++){var g=e[f].replace(/['"]/g,"");-1==g.indexOf(" ")?d.push(g):d.push("'"+g+"'")}d=d.join(",");e="normal";"o"===b.O?e="oblique":"i"===b.O&&(e="italic");c.style.cssText="display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+d+";"+("font-style:"+e+";font-weight:"+(b.Z+"00")+";")}
  function N(a){r(a.d,"body",a.o)}L.prototype.remove=function(){var a=this.o;a.parentNode&&a.parentNode.removeChild(a)};function O(a,b,c,d,e,f,g,h){this.$=a;this.ka=b;this.d=c;this.m=d;this.k=e;this.I=h||"BESbswy";this.v={};this.X=f||3E3;this.ca=g||null;this.H=this.u=this.t=null;this.t=new L(this.d,this.I);this.u=new L(this.d,this.I);this.H=new L(this.d,this.I);M(this.t,new H("serif",I(this.m)));M(this.u,new H("sans-serif",I(this.m)));M(this.H,new H("monospace",I(this.m)));N(this.t);N(this.u);N(this.H);this.v.serif=this.t.o.offsetWidth;this.v["sans-serif"]=this.u.o.offsetWidth;this.v.monospace=this.H.o.offsetWidth}
  var P={sa:"serif",ra:"sans-serif",qa:"monospace"};O.prototype.start=function(){this.oa=n();M(this.t,new H(this.m.getName()+",serif",I(this.m)));M(this.u,new H(this.m.getName()+",sans-serif",I(this.m)));Q(this)};function R(a,b,c){for(var d in P)if(P.hasOwnProperty(d)&&b===a.v[P[d]]&&c===a.v[P[d]])return!0;return!1}
  function Q(a){var b=a.t.o.offsetWidth,c=a.u.o.offsetWidth;b===a.v.serif&&c===a.v["sans-serif"]||a.k.ga&&R(a,b,c)?n()-a.oa>=a.X?a.k.ga&&R(a,b,c)&&(null===a.ca||a.ca.hasOwnProperty(a.m.getName()))?S(a,a.$):S(a,a.ka):ja(a):S(a,a.$)}function ja(a){setTimeout(k(function(){Q(this)},a),50)}function S(a,b){a.t.remove();a.u.remove();a.H.remove();b(a.m)};function T(a,b,c,d){this.d=b;this.A=c;this.S=0;this.ea=this.ba=!1;this.X=d;this.k=a.k}function ka(a,b,c,d,e){c=c||{};if(0===b.length&&e)J(a.A);else for(a.S+=b.length,e&&(a.ba=e),e=0;e<b.length;e++){var f=b[e],g=c[f.getName()],h=a.A,m=f;h.F&&s(h.q,[h.h.e(h.j,m.getName(),I(m).toString(),"loading")]);K(h,"fontloading",m);h=null;h=new O(k(a.ia,a),k(a.ja,a),a.d,f,a.k,a.X,d,g);h.start()}}
  T.prototype.ia=function(a){var b=this.A;b.F&&s(b.q,[b.h.e(b.j,a.getName(),I(a).toString(),"active")],[b.h.e(b.j,a.getName(),I(a).toString(),"loading"),b.h.e(b.j,a.getName(),I(a).toString(),"inactive")]);K(b,"fontactive",a);this.ea=!0;la(this)};
  T.prototype.ja=function(a){var b=this.A;if(b.F){var c=t(b.q,b.h.e(b.j,a.getName(),I(a).toString(),"active")),d=[],e=[b.h.e(b.j,a.getName(),I(a).toString(),"loading")];c||d.push(b.h.e(b.j,a.getName(),I(a).toString(),"inactive"));s(b.q,d,e)}K(b,"fontinactive",a);la(this)};function la(a){0==--a.S&&a.ba&&(a.ea?(a=a.A,a.F&&s(a.q,[a.h.e(a.j,"active")],[a.h.e(a.j,"loading"),a.h.e(a.j,"inactive")]),K(a,"active")):J(a.A))};function U(a){this.K=a;this.B=new ia;this.pa=new B(a.navigator.userAgent);this.a=this.pa.parse();this.U=this.V=0;this.R=this.T=!0}
  U.prototype.load=function(a){this.d=new q(this.K,a.context||this.K);this.T=!1!==a.events;this.R=!1!==a.classes;var b=new ha(this.d,a),c=[],d=a.timeout;b.F&&s(b.q,[b.h.e(b.j,"loading")]);K(b,"loading");var c=this.B,e=this.d,f=[],g;for(g in a)if(a.hasOwnProperty(g)){var h=c.C[g];h&&f.push(h(a[g],e))}c=f;this.U=this.V=c.length;a=new T(this.a,this.d,b,d);d=0;for(g=c.length;d<g;d++)e=c[d],e.L(this.a,k(this.la,this,e,b,a))};
  U.prototype.la=function(a,b,c,d){var e=this;d?a.load(function(a,b,d){ma(e,c,a,b,d)}):(a=0==--this.V,this.U--,a&&0==this.U?J(b):(this.R||this.T)&&ka(c,[],{},null,a))};function ma(a,b,c,d,e){var f=0==--a.V;(a.R||a.T)&&setTimeout(function(){ka(b,c,d||null,e||null,f)},0)};function na(a,b,c){this.P=a?a:b+oa;this.s=[];this.W=[];this.fa=c||""}var oa="//fonts.googleapis.com/css";na.prototype.e=function(){if(0==this.s.length)throw Error("No fonts to load!");if(-1!=this.P.indexOf("kit="))return this.P;for(var a=this.s.length,b=[],c=0;c<a;c++)b.push(this.s[c].replace(/ /g,"+"));a=this.P+"?family="+b.join("%7C");0<this.W.length&&(a+="&subset="+this.W.join(","));0<this.fa.length&&(a+="&text="+encodeURIComponent(this.fa));return a};function pa(a){this.s=a;this.da=[];this.M={}}
  var qa={latin:"BESbswy",cyrillic:"&#1081;&#1103;&#1046;",greek:"&#945;&#946;&#931;",khmer:"&#x1780;&#x1781;&#x1782;",Hanuman:"&#x1780;&#x1781;&#x1782;"},ra={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},sa={i:"i",italic:"i",n:"n",normal:"n"},ta=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
  pa.prototype.parse=function(){for(var a=this.s.length,b=0;b<a;b++){var c=this.s[b].split(":"),d=c[0].replace(/\+/g," "),e=["n4"];if(2<=c.length){var f;var g=c[1];f=[];if(g)for(var g=g.split(","),h=g.length,m=0;m<h;m++){var l;l=g[m];if(l.match(/^[\w-]+$/)){l=ta.exec(l.toLowerCase());var p=void 0;if(null==l)p="";else{p=void 0;p=l[1];if(null==p||""==p)p="4";else var fa=ra[p],p=fa?fa:isNaN(p)?"4":p.substr(0,1);l=l[2];p=[null==l||""==l?"n":sa[l],p].join("")}l=p}else l="";l&&f.push(l)}0<f.length&&(e=f);
    3==c.length&&(c=c[2],f=[],c=c?c.split(","):f,0<c.length&&(c=qa[c[0]])&&(this.M[d]=c))}this.M[d]||(c=qa[d])&&(this.M[d]=c);for(c=0;c<e.length;c+=1)this.da.push(new H(d,e[c]))}};function V(a,b){this.a=(new B(navigator.userAgent)).parse();this.d=a;this.f=b}var ua={Arimo:!0,Cousine:!0,Tinos:!0};V.prototype.L=function(a,b){b(a.k.Y)};V.prototype.load=function(a){var b=this.d;"MSIE"==this.a.getName()&&1!=this.f.blocking?ca(b,k(this.aa,this,a)):this.aa(a)};
  V.prototype.aa=function(a){for(var b=this.d,c=new na(this.f.api,u(b),this.f.text),d=this.f.families,e=d.length,f=0;f<e;f++){var g=d[f].split(":");3==g.length&&c.W.push(g.pop());var h="";2==g.length&&""!=g[1]&&(h=":");c.s.push(g.join(h))}d=new pa(d);d.parse();v(b,c.e());a(d.da,d.M,ua)};function W(a,b){this.d=a;this.f=b;this.p=[]}W.prototype.J=function(a){var b=this.d;return u(this.d)+(this.f.api||"//f.fontdeck.com/s/css/js/")+(b.w.location.hostname||b.K.location.hostname)+"/"+a+".js"};
  W.prototype.L=function(a,b){var c=this.f.id,d=this.d.w,e=this;c?(d.__webfontfontdeckmodule__||(d.__webfontfontdeckmodule__={}),d.__webfontfontdeckmodule__[c]=function(a,c){for(var d=0,m=c.fonts.length;d<m;++d){var l=c.fonts[d];e.p.push(new H(l.name,ga("font-weight:"+l.weight+";font-style:"+l.style)))}b(a)},w(this.d,this.J(c),function(a){a&&b(!1)})):b(!1)};W.prototype.load=function(a){a(this.p)};function X(a,b){this.d=a;this.f=b;this.p=[]}X.prototype.J=function(a){var b=u(this.d);return(this.f.api||b+"//use.typekit.net")+"/"+a+".js"};X.prototype.L=function(a,b){var c=this.f.id,d=this.d.w,e=this;c?w(this.d,this.J(c),function(a){if(a)b(!1);else{if(d.Typekit&&d.Typekit.config&&d.Typekit.config.fn){a=d.Typekit.config.fn;for(var c=0;c<a.length;c+=2)for(var h=a[c],m=a[c+1],l=0;l<m.length;l++)e.p.push(new H(h,m[l]));try{d.Typekit.load({events:!1,classes:!1})}catch(p){}}b(!0)}},2E3):b(!1)};
  X.prototype.load=function(a){a(this.p)};function Y(a,b){this.d=a;this.f=b;this.p=[]}Y.prototype.L=function(a,b){var c=this,d=c.f.projectId,e=c.f.version;if(d){var f=c.d.w;w(this.d,c.J(d,e),function(e){if(e)b(!1);else{if(f["__mti_fntLst"+d]&&(e=f["__mti_fntLst"+d]()))for(var h=0;h<e.length;h++)c.p.push(new H(e[h].fontfamily));b(a.k.Y)}}).id="__MonotypeAPIScript__"+d}else b(!1)};Y.prototype.J=function(a,b){var c=u(this.d),d=(this.f.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return c+"//"+d+"/"+a+".js"+(b?"?v="+b:"")};
  Y.prototype.load=function(a){a(this.p)};function Z(a,b){this.d=a;this.f=b}Z.prototype.load=function(a){var b,c,d=this.f.urls||[],e=this.f.families||[],f=this.f.testStrings||{};b=0;for(c=d.length;b<c;b++)v(this.d,d[b]);d=[];b=0;for(c=e.length;b<c;b++){var g=e[b].split(":");if(g[1])for(var h=g[1].split(","),m=0;m<h.length;m+=1)d.push(new H(g[0],h[m]));else d.push(new H(g[0]))}a(d,f)};Z.prototype.L=function(a,b){return b(a.k.Y)};var $=new U(this);$.B.C.custom=function(a,b){return new Z(b,a)};$.B.C.fontdeck=function(a,b){return new W(b,a)};$.B.C.monotype=function(a,b){return new Y(b,a)};$.B.C.typekit=function(a,b){return new X(b,a)};$.B.C.google=function(a,b){return new V(b,a)};this.WebFont||(this.WebFont={},this.WebFont.load=k($.load,$),this.WebFontConfig&&$.load(this.WebFontConfig));})(this,document);


/**
 * only send prod js errors to bugsnag - too noisy otherwise
 */
if(!(window.location.hostname == "asana.com" ||
  window.location.hostname == "blog.asana.com")) {
  Bugsnag.releaseStage = "development";
}
Bugsnag.notifyReleaseStages = ["production"];

/**
 * Anything up here BLOCKS PAGE LOAD - exercise extreme caution.
 * Functions are probably okay - as long as they don't load 3rd party content
 * We're putting global helpers into a custom object to avoid namespace issues
 */

/**
 * Data Layer - object that contains all the data to be passed to Google Tag Manager, must be called before GTM
 * see https://developers.google.com/tag-manager/devguide
 */
dataLayer = [];

/**
 * Google Auth
 * js include & initialization
 * stubs required for browser_google_auth.js
 */
req = noop = function () {
};

/**
 * This is a non-authoritative copy of our browser google auth code.
 * We're copying it to the static site so we can serve it over http
 * more immediately. (from the non-static site, we require https, and
 * end up doing a few redirects before achieving this)
 *
 */

req('luna/browser/dynamic_loader.js');
req('luna/common/uri.js');

/**
 * ##OAuth
 *
 * Client-side support for OAuth to Google services. This is a way of
 * initiating the flow that lets users authorize the Asana app to access
 * information associated with the user's Google Account, such as their
 * list of Gmail contacts.
 *
 * The app used is under the following account:
 *   api@asana.com
 *
 * Once logged-in, you can administer this account (redirects, allowed origins,
 * etc.) at the following URL:
 *   https://code.google.com/apis/console
 *
 * OAuth2 overview:
 *   http://code.google.com/apis/accounts/docs/OAuth2.html
 */

// This is not an AsanaObject since we need to use this code at the login
// screen when lib.js has not been loaded yet.
BrowserGoogleAuth = function(onComplete) {
    this._callbackOnComplete = onComplete;
};

BrowserGoogleAuth.InitializationState = {
    NOT_STARTED: "NOT_STARTED",
    STARTED: "STARTED",
    COMPLETE: "COMPLETE"
};

BrowserGoogleAuth._running_instance = null;

BrowserGoogleAuth._initialization_state =
    BrowserGoogleAuth.InitializationState.NOT_STARTED;

BrowserGoogleAuth._test_data = undefined;

/**
 * attributes should be null, or have keys:
 *
 * status: optional. non-zero to indicate that the server-side authentication failed. Default 0 (success).
 * email: email of the auth'ed user, as returned by google.
 * name: optional name of the auth'ed user, as returned by google. Defaults to email.
 * verified_email: optional boolean indicating if Google has verified this user's email. Default true.
 *
 * @param attributes?
 */
BrowserGoogleAuth.setTestData = function(attributes) {
    if (attributes === null) {
        BrowserGoogleAuth._test_data = null;
    } else if (attributes.access_token !== undefined) {
        BrowserGoogleAuth._test_data = { access_token: attributes.access_token };
    } else {
        var test_data = {};
        test_data.status = attributes.status || 200;
        // Support both new and #DeprecatedGoogleAuth
        // #FakeGoogleAuthResponse
        test_data.body = JSON.stringify({
            emails: [{ value: attributes.email }],
            displayName: attributes.name || attributes.email,
            email: attributes.email,
            name: attributes.name || attributes.email,
            verified_email: attributes.verified_email === undefined
                ? true
                : attributes.verified_email
        });
        BrowserGoogleAuth._test_data = { access_token: JSON.stringify(test_data) };
    }
};

/**
 * Unsubscribes the oncomplete function and removes the running instance.
 */
BrowserGoogleAuth.reset = function() {
    if (BrowserGoogleAuth._running_instance !== null) {
        BrowserGoogleAuth._running_instance._callbackOnComplete = noop;
        BrowserGoogleAuth._running_instance = null;
    }
    window.onAuthorizedNewUserInPopup = noop;
};

/**
 * Perform the entire Google authentication process using redirects (rather
 * than popups). Once authenticated, continue to target_url.
 * @param oauth_action_url The Oauth endpoint to use on the asana server
 * @param target_url The url to continue to once the authentication is complete.
 */
BrowserGoogleAuth.authorizeUsingRedirects = function(oauth_action_url, target_url, is_create) {
    if(document.URL.indexOf("signup-with-google-redirects") > 0){
        window.location.href = 'https://accounts.google.com/o/oauth2/auth?' +
            'redirect_uri=' + oauth_action_url + '&' +
            'response_type=code&client_id=1032199425885-oq9scukspijc682n7k2erv386nc58que.apps.googleusercontent.com&' +
            // NOTE: if you change this, make sure you change the corresponding code
            // in ViewController.m (part of the iOS app) !!
            'scope=email+profile&' +
            'state=' + target_url + (is_create ? "+create+https://asana.com" : "" );
    } else {
        window.location.href = 'https://accounts.google.com/o/oauth2/auth?' +
            'redirect_uri=' + oauth_action_url + '&' +
            'response_type=code&client_id=1032199425885-oq9scukspijc682n7k2erv386nc58que.apps.googleusercontent.com&' +
            // NOTE: if you change this, make sure you change the corresponding code
            // in ViewController.m (part of the iOS app) !!
            'scope=email+profile+' +
            'http%3A%2F%2Fwww.google.com%2Fm8%2Ffeeds&' +
            'state=' + target_url + (is_create ? "+create+https://asana.com" : "" );
    }
};

/**
 * Set up the OAuth process. This loads the necessary apis and initializes oauth.
 */
BrowserGoogleAuth.init = function() {
    if (BrowserGoogleAuth._test_data !== undefined) {
        return;
    }
    if (BrowserGoogleAuth._initialization_state ===
        BrowserGoogleAuth.InitializationState.NOT_STARTED) {
        BrowserGoogleAuth._initialization_state =
            BrowserGoogleAuth.InitializationState.STARTED;
        BrowserGoogleAuth._ensureGoogleApiLoaded();
    }
};

BrowserGoogleAuth._ensureGoogleApiLoaded = function() {
    if (typeof(env) !== "undefined" && env.is_server) {
        return;
    }
    var gapi_url = "https://apis.google.com/js/client.js";
    if (typeof(DynamicLoader) !== "undefined") {
        DynamicLoader.get().load({
            url: gapi_url,
            callback: function() {
                BrowserGoogleAuth._onGoogleApiLoaded();
            },
            callback_param_name: "onload"
        });
    } else {
        // If this code is running before luna code has been loaded (i.e login
        // screen), we don't have access to DynamicLoader google apis, so we
        // manually do the part of DynamicLoader that we need.
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = gapi_url;
        script.addEventListener("load", BrowserGoogleAuth._onGoogleApiLoaded, true);
        document.getElementsByTagName("head")[0].appendChild(script);
    }
};

BrowserGoogleAuth._onClientLoaded = function() {
    gapi.client.setApiKey("Asana-ContactImporter");
    // This call is needed to make sure we don't get blocked by the pop up
    // blocker in the authorize step.
    gapi.auth.init(function() {
        BrowserGoogleAuth._initialization_state =
            BrowserGoogleAuth.InitializationState.COMPLETE;
    });
};

BrowserGoogleAuth._onGoogleApiLoaded = function() {
    // ##GoogleLoadsCodeAsyncronously
    // It looks like https://apis.google.com/js/client.js asynchronously loads
    // more code. We've also gotten burned somewhat by just waiting for certain
    // components to be defined -- so instead we just use the brute force
    // approach.
    try {
        gapi.client.load("oauth2", "v2", BrowserGoogleAuth._onClientLoaded);
    } catch (e) {
        setTimeout(BrowserGoogleAuth._onGoogleApiLoaded, 5); // nolint
    }
};

/**
 * Start the OAuth process. This may open up new browser windows that
 * direct the user to go through a Google flow.
 *
 * Will fail if the user aborts the flow, denies authorization, or if the
 * flow is already in progress when start() is called a second time.
 *
 * @param onComplete {Function(auth_result: dict?} Callback to run when
 *     completed. Will receive an auth result (containing the auth token)
 *     on success, or null on any kind of failure. The result has the fields:
 *       access_token {String} Short-lived token providing access.
 *       token_type {String} Type of token, should be "Bearer".
 *       expires_in {Integer} Number of seconds token is valid for.
 *       refresh_token {String} A token to supply on a refresh request to
 *           get a new token when access expires.
 *
 * The next arguments are all options @param opt_args
 * @param force_new_user {Boolean} If true, will got through the google
 *     auth flow that asks the user the sign in with another account.
 * @param user_email {String} The email of the user to  authenticate. This
 *    is used if there are several users logged in to tell Google which one to
 *    pick.
 * @param redirect_path {String} The path to redirect to after the user
 *    authenticates with google. Will use oauth2callback_new_login if not set.
 * @param for_drive {Boolean} If true, scope to just google drive permissions
 *
 */
BrowserGoogleAuth.start = function(onComplete, opt_force_new_user, opt_user_email) {
    if (BrowserGoogleAuth._test_data !== undefined) {
        // Run this in a timeout since the real authentication flow is also async.
        // Try to use safeTimeout if it is defined, otherwise it doesn't matter since
        // our code has not been loaded so we can just use setTimeout.
        var setTimeoutFunc = globals.safeTimeout || setTimeout;
        setTimeoutFunc(function() { onComplete(BrowserGoogleAuth._test_data); }, 0); //nolint
        return;
    }

    if (opt_force_new_user) {
        var oauth = new BrowserGoogleAuth(onComplete); //nolint
        oauth._authorizeNewUser();
    } else if (BrowserGoogleAuth._initialization_state !==
        BrowserGoogleAuth.InitializationState.COMPLETE) {
        BrowserGoogleAuth.authorizeUsingRedirects('https://app.asana.com/-/oauth2callback','https://app.asana.com',true);
    } else {
        try{
            var oauth = new BrowserGoogleAuth(onComplete); //nolint
            oauth._start(opt_user_email);
        } catch(e) {
            console.log(e);
            BrowserGoogleAuth.authorizeUsingRedirects('https://app.asana.com/-/oauth2callback','https://app.asana.com',true);
        }
    }
};

/**
 * Start the OAuth process and ask the user to login with an additional google
 * account.
 *
 * Note: this method relies on luna libraries, so it can only run when those
 * libraries have been loaded.
 */
BrowserGoogleAuth.prototype._authorizeNewUser = function() {
    var self = this;
    BrowserGoogleAuth._running_instance = self;
    var continue_params = {
        redirect_uri: 'https://' + Flags.secure_web_host_port + '/-/oauth2callback_new_login',
        response_type: 'code',
        // The client ID is from an OAuth-ready app registered to
        // the user api@asana.com.
        // TODO: put this in a flag.
        client_id: '1032199425885-oq9scukspijc682n7k2erv386nc58que.apps.googleusercontent.com',
        // For now just including contacts since the only user of this code is the
        // contact importer for lightweight projects.
        scope: URI.encodeComponent('http://www.google.com/m8/feeds')
    };

    var continue_url = 'https://accounts.google.com/o/oauth2/auth?' +
        URI.buildQueryStringNoEncoding(
            continue_params, /*opt_equals=*/'%3D', /*opt_ampersand=*/'%26');

    var params = {
        service: 'lso',
        'continue': continue_url
    };
    var auth_url = 'https://www.google.com/accounts/AddSession?' +
        URI.buildQueryStringNoEncoding(params);
    window.openAsync(auth_url,'name', 'height=518,width=879');
    window.onAuthorizedNewUserInPopup = function(auth_response) {
        BrowserGoogleAuth._onAuthorizedNewUserInPopup(self, auth_response);
    };
    BrowserGoogleAuth._running_instance = null;
};

BrowserGoogleAuth._onAuthorizedNewUserInPopup = function(instance, auth_response) {
    instance._onAuthorized(auth_response);
};

BrowserGoogleAuth.prototype._start = function(opt_user_email, opt_for_drive) {
    var me = this;
    BrowserGoogleAuth._running_instance = me;
    me._authorize(opt_user_email, opt_for_drive);
};

BrowserGoogleAuth.prototype._authorize = function(opt_user_email, opt_for_drive) {
    var me = this;
    var scope = opt_for_drive ?
        ["https://www.googleapis.com/auth/drive.readonly"] :
        [
            "email",
            "profile",
            "http://www.google.com/m8/feeds/"
        ];
    console.log("Calling gapi.auth.authorize");
    gapi.auth.authorize({
        // The client ID is from an OAuth-ready app registered to
        // the user api@asana.com.
        // TODO: put this in a flag.
        client_id: "1032199425885-oq9scukspijc682n7k2erv386nc58que.apps.googleusercontent.com",
        // The scope is the set of things we want access to. This will be
        // determined by what APIs we want to use, and since right now we
        // are only in use for the contacts API, this is what we request.
        //
        // TODO#Node Note we don't request https access, because we lacked the
        // ability to make a secure request from v8cgi. Now that we're on Node we
        // should revisit this.
        scope: scope,
        // Setting this to be an empty string to force google to ask which
        // account the user wants to use, if using multiple sign in.
        authuser: opt_user_email || ""
        // Other scopes/APIs we have requested access to when fiddling with
        // this API.
        //scope: "https://www.googleapis.com/auth/plus.me"
        //scope: "http://www-opensocial.googleusercontent.com/api/people"
    }, function(auth_response) {
        console.log("Got gapi.auth.authorize callback");
        me._onAuthorized(auth_response);
    });
};


/**
 * Handle the next step after getting an authorization token from Google.
 *
 * @param auth_response {dict} A response from the OAuth service at Google,
 *     of the form:
 *     {
 *       "access_token" : "ya29.AHES6ZRVcCEB6Ju9joctYaWK3t4XXT7VDhHMn_JM5x32P1M",
 *       "token_type" : "Bearer",
 *       "expires_in" : 3600,
 *       "refresh_token" : "1/nWZM0ecCk6X1ZhWEhpF-YKLRlmuGRvP2qfIGUg4viDc"
 *       "email" : "eng+sushi@asana.com"
 *     }
 *
 *     Note the email is only provided if force_new_user was true.
 */
BrowserGoogleAuth.prototype._onAuthorized = function(auth_response) {
    var me = this;
    if (auth_response !== null) {
        me._onComplete(auth_response);
    } else {
        me._onComplete(null);
    }
};

BrowserGoogleAuth.prototype._onComplete = function(result) {
    var me = this;
    BrowserGoogleAuth._running_instance = null;
    me._callbackOnComplete.call(null, result);
};


BrowserGoogleAuth.init();


/**
 * top-level utilities for all asana sites
 */
AsanaHelpers = {

  XSRF_TOKEN: false,
  BLANK_SIGNUP_TRIES: 0,

  /**
   * set the XSRF token - TODO:CheckWithManoj
   */
  initializeSecurityToken: function() {
    var existing_xsrf_token = this.getCookie("xsrf_token");
    if(existing_xsrf_token) {
      this.XSRF_TOKEN = existing_xsrf_token;
    } else {
      var new_security_token = Math.random().toString(36).substring(2);
      this.setCookie("xsrf_token", new_security_token, 1/24, true); // expires in 1hr
      this.XSRF_TOKEN = new_security_token;
    }
  },

  /**
   * add the XSRF token to all forms
   */
  addSecurityTokenToForms: function() {
    if(this.XSRF_TOKEN){
      jQuery("form").append("<input type='hidden' name='xsrf_token' value='" +
        this.XSRF_TOKEN + "' >");
    } else {
      throw new Exception("Security token not properly set");
    }
  },

  /**
   * if on localhost, use sandbox, otherwise go to the web app
   * append options for signup, auth, and experiments to url
   */
  appUrl: function(opt_suffix) {
    if (opt_suffix === undefined) {
      opt_suffix = "";
    }

    if (window.location.hostname === "localhost.asana.com" ||
        window.location.hostname === "localhost") {
      return "https://localhost.asana.com:8180" + opt_suffix;
    } else {
      return "https://app.asana.com" + opt_suffix;
    }

  },

  isProduction: function() {
    return (window.location.host === "asana.com" ||
      window.location.host === "blog.asana.com");
  },

  /**
   * tests to see if the browser’s userAgent matches iOS, Android, or IE
   * returns a string which is used in setGlobalClasses() and mobilePlatform()
   */
  specialPlatform: function () {
    var ua = navigator.userAgent;
    if (ua.match(/(iPhone|iPod|iPad)/)) {
      return "ios";
    } else if (ua.match(/Android/)) {
      return "android";
    } else if (ua.match(/MSIE/)) {
      return "ie";
    } else {
      return false;
    }
  },

  /**
   * returns true for either android or ios userAgents
   */
  mobilePlatform: function() {
    return (
      this.specialPlatform() == "ios" ||
      this.specialPlatform() == "android"
      );
  },

  /**
   * returns true if the cookie for logged in exists
   * used in setGlobalClasses()
   */
  isLoggedIn: function () {
    return document.cookie.indexOf("is_logged_in") !== -1;
  },

  /**
   * returns the value of a cookie if you know the key name
   */
  getCookie: function (name) {
    var value = document.cookie;
    var start = value.indexOf(" " + name + "=");
    if (start == -1) {
      start = value.indexOf(name + "=");
    }
    if (start == -1) {
      value = null;
    } else {
      start = value.indexOf("=", start) + 1;
      var end = value.indexOf(";", start);
      if (end == -1) {
        end = value.length;
      }
      value = unescape(value.substring(start, end));
    }
    return value;
  },

  /**
   * Set a non-http-only cookie with Javascript
   * NOTE - EXERCISE EXTREME CAUTION CHANGING THIS FUNCTION.  Breaking cookies
   * will break XSRF protection, which will break all form submittal, including
   * Login/Signup to the app.
   *
   * @param name - the name of the cookie
   * @param value - value of cookie
   * @param expires_in_days
   * @param cross_domain - whether or not this applies to *.asana.com
   */
  setCookie: function (name, value, expires_in_days, cross_domain) {
    cross_domain = typeof cross_domain !== 'undefined' ? true : false;
    var d = new Date();
    d.setTime(d.getTime() + (expires_in_days*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    var cookie_string = (name + "=" + value + ";" + expires +
      ";path=/") +
      (cross_domain === true ? ";domain=.asana.com" : "") +
      (location.protocol === "https:" ? ";secure" : "") ;
    document.cookie = cookie_string;

    // firefox doesn't let us set a cookie with a domain (?!)
    if(!this.getCookie("xsrf_token")) {
      document.cookie = name + "=" + value + ";";
    }
  },

  /**
   * Set a cookie with information on where the user came from - primarily
   * for ad attribution. A more robust system here would set a numeric cookie
   * and then send all visits/events somewhere where we can reconstruct the
   * whole user journey, but when we've tried that in the past it has been too
   * data-intensive.
   */
  updateAttributionCookie: function() {

    var most_recent_visit = {
      source: document.referrer,
      query_string: document.location.search,
      exit_page: document.location.pathname,
      landing_page: document.location.pathname,
      useragent: navigator.userAgent,
      timestamp: Math.floor(Date.now() / 1000)
    };

    // set a 30d cookie with information on the user's first visit
    if(!this.getCookie("asana_orig_attr")) {
      this.setCookie("asana_orig_attr",
        encodeURIComponent(JSON.stringify(most_recent_visit)), 30, true);
    } else {
      // add the first visit information into the data for the main attribution
      // cookie - since that is all that we send with the signups
      most_recent_visit.cookie = JSON.parse(this.getCookie("asana_orig_attr"));
    }

    // prepare the cookie that we'll send with any signups - the "origin" of the
    // current "session" (the first visit within the past hour)
    if(!this.getCookie("asana_attr")) {
      this.setCookie("asana_attr",
        encodeURIComponent(JSON.stringify(most_recent_visit)), 1/24, true);
    } else {
      // if we already have a cookie, update and send the current page, which
      // will be the "exit page" if a user signs up or leaves
      var existing_cookie = JSON.parse(this.getCookie("asana_attr"));
      existing_cookie.exit_page = document.location.pathname;
      this.setCookie("asana_attr",
        encodeURIComponent(JSON.stringify(existing_cookie)), 1/24, true);
    }
  },

  /**
   * sets global classes for specific devices/platforms based on userAgents
   * see specialPlatform(), mobilePlatform(), and isLoggedIn()
   */
  setGlobalClasses: function () {

    if(this.specialPlatform() === "ios") {
      jQuery("html").addClass("device-ios");
    }

    if(this.specialPlatform() === "android") {
      jQuery("html").addClass("device-android");
    }

    if(this.mobilePlatform()) {
      jQuery("html").addClass("device-mobile");
    }

    if(this.isLoggedIn()) {
      jQuery("html").addClass("asana-is-logged-in");
    }

  },

  /**
   * REDIRECT GOOGLE APPS MARKETPLACE PEOPLE
   * talk to AlexD/JK if you have questions about this
   */
  redirectGoogleAppMarketplaceClicks: function() {
    var prmarr = window.location.search.substr(1).split('&');
    var params = {};
    for ( var i = 0; i < prmarr.length; i++) {
      var tmparr = prmarr[i].split("=");
      params[tmparr[0]] = unescape(tmparr[1]);
    }
    if (params.action == "signup-with-google-redirects")  {
      BrowserGoogleAuth.authorizeUsingRedirects(AsanaHelpers.appUrl('/-/oauth2callback'), AsanaHelpers.appUrl(), true);
    }
  },

  /**
   * stackoverflow.com/questions/46155/validate-email-address-in-javascript
   * @param email {string} a test string
   * @returns {boolean} whether or not string is a valid email address
   */
  validateEmail: function (email) {
    var re = /^([a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i;
    return re.test(email);
  },

  /**
   * Pushes event data array into the dataLayer for Google Analytics
   * see https://developers.google.com/tag-manager/devguide
   *
   * EXAMPLES:
   * event: 'UA-Login', 'UA-Signup', 'UA-BadAuth', 'signup', 'ExistingUserSignUp'
   * eventCategory: 'Login', 'Signup',  'Video', 'Blog', 'Contact', 'Social', etc
   * eventAction: 'Click', 'Play', 'Subscribe', 'Mail', 'GoogleAuth', 'Submit', etc
   * eventLabel: 'Header', 'Modal', 'Homepage', 'Jobs Video', 'Support', etc
   */
  pushEventToGA: function(list) {
    if(list.length === 3){
      dataLayer.push({
        "event": "UA-" + list[0],
        "eventCategory": list[0],
        "eventAction": list[1],
        "eventLabel": list[2]
      });
    } else if (list.length === 4) {
      dataLayer.push({
        "event": "UA-" + list[0],
        "eventCategory": list[0],
        "eventAction": list[1],
        "eventLabel": list[2],
        "eventValue": list[3]
      });
    } else {
      Bugsnag.notifyException("Failed to send event to GA",
        "Incorrect # of parameters");
    }
  },

  /** Our modals are #anchored elements styled via :target attributes, so you just
    * need to navigate to them! Pass the modal's ID in to simulate visiting that URL
    *
    */
  showModal: function (modal) {
    window.location.hash = modal;
  },

  /**
   * Begins login modal flow:
   * 1. Pushes a login event to GA
   * 2. If the browser is iOS or Android, just a redirect to the web version. see appURL()
   * 3. Otherwise, show the login modal
   *    and focus the email field unless you’re on IE, which hides the placeholder in the text field onFocus
   */
  showLoginModal: function () {

    // TODO:GTM - http://abhishek-tiwari.com/post/event-tracking-with-data-layer-and-data-attributes
    // _gaq.push(["_trackEvent", "Login", "Click", "Header"]);
    dataLayer.push({
      "event": "UA-Login",
      "eventCategory": "Login",
      "eventAction": "Click",
      "eventLabel": "Header"
    });

    if (this.mobilePlatform()) {
      window.location = AsanaHelpers.appUrl("/");
      return false;
    }

    AsanaHelpers.showModal("login");
    if(!this.specialPlatform()) {
      // ie and mobile prevent the placeholder from being visible and/or pop
      // up a keyboard
      jQuery("#login-email-login-modal").focus();
    }
  },

  /**
   * Begins the Google Auth signup flow, approximately 1/3rds of signups, pushes relevant analytics data
   */
  signupWithGoogle: function () {

    BrowserGoogleAuth.start(function(auth_response) {
      if (auth_response === null) {
        // The user must have denied access from google, so do nothing.
        return;
      }
      // This checks for the existence of the user in our system using the Auth Token from google. The POST should return a JSON object { status : "new/existing/error" }
      jQuery.ajax({
        url : "proxy_auth_check.php",
        type : "POST",
        dataType : "json",
        data : { auth: auth_response.access_token },
        timeout : 5000,
        success : function(data) {

          if(data.status.http_code === 200) {
            // Hack bc we"re getting the whole http response back and we just want the json object.
            var arr = data.contents.split("\n");
            var contents = jQuery.parseJSON(arr[arr.length - 1]);
            if (contents.status === "new") {

              window.optimizely.push(["trackEvent", "all_signup"]);
              window.optimizely.push(["trackEvent", "signupGoogle"]);
              dataLayer.push({"event": "signup"});

              // TODO: GTM - _gaq.push(["_trackEvent", "SignUp", "GoogleAuth", document.URL]);
              dataLayer.push({
                "event": "UA-Signup",
                "eventCategory": "SignUp",
                "eventAction": "GoogleAuth",
                "eventLabel": document.URL
              });

            } else if (contents.status === "existing") {

              // TODO:GTM - _gaq.push(["_trackEvent", "Login", "GoogleAuth", document.URL]);
              dataLayer.push({
                "event": "UA-Login",
                "eventCategory": "Login",
                "eventAction": "GoogleAuth",
                "eventLabel": document.URL
              });

              dataLayer.push({"event": "login"});
              window.optimizely.push(["trackEvent", "loginGoogle"]);
            } else if (contents.status === "bad_google_auth") {

              // TODO:GTM - _gaq.push(["_trackEvent", "BadAuth", "GoogleAuth", document.URL]);
              dataLayer.push({
                "event": "UA-BadAuth",
                "eventCategory": "BadAuth",
                "eventAction": "GoogleAuth",
                "eventLabel": document.URL
              });

            } else {
              return;
            }
          }
        },
        error : function(jqXHR, textStatus, errorThrown) {
          //console.log("status: " + textStatus);
          //console.log("error: " + errorThrown);
          Bugsnag.notifyException(errorThrown, "Failed Google SSO Signup");
        },
        complete : function() {

          try {
            AsanaHelpers.showModal("loading");
          } catch(e) {

          }

          var form = document.createElement("form");
          form.setAttribute("id","google_auth_form");
          form.setAttribute("method", "POST");
          form.setAttribute("action", AsanaHelpers.appUrl("/-/signup"));
          var addField = function(name, value) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", name);
            hiddenField.setAttribute("value", value);
            form.appendChild(hiddenField);
          };
          addField("src", "simple-signup");
          addField("i", "google");
          addField("auth", auth_response.access_token);
          try {
            addField("extra", AsanaHelpers.getCookie("asana_attr"));
            addField("experiments", AsanaHelpers.experimentVariants());
          } catch(e) {
            console.log(e);
          }
          document.body.appendChild(form);

          // give analytics events a chance to fire
          setTimeout("jQuery('#google_auth_form').submit();",300); // jshint ignore:line
        }
      });

    });
    return false;

  },

  /**
   * Begins the email signup flow, approximately 2/3rds of signups, pushes
   * relevant analytics data
   */
  signupWithEmail: function(email_input, opt_asked_for_oath) {

    // if opt_asked_for_oath is passed (true), it means they user should have already seen an Oath button and chose to enter an email anyways. Don't ask them to consider Oath again

    // if opt_asked_for_oath was not passed, or passed false, the user shouldn't have seen an Oath button yet and should be asked to consider Oath if they enter a gmail account

    opt_asked_for_oath = typeof opt_asked_for_oath !== 'undefined' ?
      opt_asked_for_oath : false;

    if(email_input.val() === "" && this.BLANK_SIGNUP_TRIES < 1){
      this.BLANK_SIGNUP_TRIES++;
      return;
    }

    // saving the email value and the associated labels and error messages for validation
    var email = email_input.val();
    var email_error_message = jQuery("#" + email_input.attr("id") + "-not-valid");
    var email_label = jQuery("label[for='" + email_input.attr("id") + "']");

    // if we want to make this code really bullet proof, we’d need to handle error cases:
    //- no id present on `email_input` and in label for= attr (we have IDs on all of these)
    //- no label attached the input (we have labels for email inputs, even if they're hidden)
    //- no error messages or error messages without -error-message appended to the end of the ID

    if(!this.validateEmail(email)){
      email_input.addClass("input--state-error");
      email_label.addClass("label--state-error");
      email_error_message.show();

    } else {

      email_input.removeClass("input--state-error");
      email_label.removeClass("label--state-error");
      email_error_message.hide();

      /**
       * A/B Testing Single Signup Button
       * If the Google Signup Button is *removed* (not just hidden), send Gmail
       * users to a modal prompting them to use Google or verify with email
       */

       // I'm not sure why we were checking to make sure that the google signup button didn't exist too
       // && jQuery("#google-signup-button").length < 1


      // if the user hasn't already been asked to consider Oath and they enter a gmail address, show the Oath modal
      // someday this should compare against a list of whitelisted email domains for known Oath accounts

      if(!opt_asked_for_oath && AsanaHelpers.endsWith(email, "@gmail.com")) {
        window.optimizely.push(["trackEvent", "show_gmail_signup_modal"]);

        // clone the email address to a hidden element in the verify modal in case they want to use it via email account
        jQuery("#verify-this-email").val(email);

        // fill in the placeholder text that shows the user their email address in the modal
        jQuery(".verify-this-email").text(email);

        AsanaHelpers.showModal("verify");
        return;
      }

      AsanaHelpers.showModal("loading");

      submitData = {};
      submitData.name = "";
      submitData.email = jQuery.trim(email);
      submitData.xsrf_token = this.XSRF_TOKEN;
      submitData.extra = this.getCookie("asana_attr");
      submitData.experiments = this.experimentVariants();

      Bugsnag.user = {
        name: submitData.name,
        email: submitData.email
      };

      jQuery.ajax({
        url : AsanaHelpers.appUrl("/-/signup"),
        type : "POST",
        dataType : "json",
        data : submitData,
        timeout : 10000,
        success : function(data) {
          if(data.status == "check-email") {
            // if user is unclaimed, treat them as new in terms of messaging, but not analytics
            if (data.user_is_new === true || data.user_is_claimed === false){
              if (data.user_is_new === true) {
                // TODO:GTM - _gaq.push(["_trackEvent", "SignUp", "Create", document.URL]);
                dataLayer.push({
                  "event": "UA-SignUp",
                  "eventCategory": "SignUp",
                  "eventAction": "Create",
                  "eventLabel": document.URL
                });

                window.optimizely.push(["trackEvent", "all_signup"]);
                window.optimizely.push(["trackEvent", "signupsubmit"]);
                dataLayer.push({"event": "signup"});
              }

              // get the address and split it by @ symbols (technically you can have multiple @'s in an email address
              var email_address_array = submitData.email.split("@");
              // get the last chunk, which will be a domain
              var email_domain_string_location = email_address_array.length -1;
              var email_domain = email_address_array[email_domain_string_location];
              // save email address domain in localStorage for next page
              localStorage.setItem('emailDomain', email_domain);

               // direct the user to the thank you page
               window.location.href = "https://asana.com/thank-you";

            } else {
              // remind them they have an account if an existing user tries to sign up
              AsanaHelpers.showModal("existing-account");
              // if they are SSO user, instruct them to use google, otherwise ask for their password
              if(data.existing_user_only_used_google_sso === true) {
                jQuery("#login-already-have-account-oath").show();

              } else {
                jQuery("#login-already-have-account-email").show();
                jQuery("#login-email-existing-account-modal").val(submitData.email);
                jQuery("#login-password-existing-account-modal").focus();
              }

              // TODO:GTM - _gaq.push(["_trackEvent", "ExistingUserSignUp", "Create", document.URL]);
              dataLayer.push({
                "event": "UA-ExistingUserSignUp",
                "eventCategory": "ExistingUserSignUp",
                "eventAction": "Create",
                "eventLabel": document.URL
              });

              window.optimizely.push(["trackEvent", "existing_user_signup"]);
              Bugsnag.notify("Mistaken Signup", "User already has an account", {}, "info");

            }
          } else {
            AsanaHelpers.showModal("signup-failed");

            Bugsnag.notify("Failed Signup", "Request succeeded but data.status != check-email " +
              JSON.stringify(data), {}, "error");

            // TODO:GTM - _gaq.push(["_trackEvent", "BadAuth", "Create", document.URL]);
            dataLayer.push({
              "event": "UA-BadAuth",
              "eventCategory": "BadAuth",
              "eventAction": "Create",
              "eventLabel": document.URL
            });

          }
        },
        error : function(jqXHR, textStatus, errorThrown) {
          AsanaHelpers.showModal("signup-failed");

          Bugsnag.notifyException(errorThrown, "Failed Signup");
        }
      });
    }
  },

  /**
   * @function subscribeToEmailList
   *
   * Subscribe an email to a Dotmailer marketing list
   *
   * @param list_id {integer} a dotmailer list ID to which we want to subscribe
   * @param email {string} an email address
   * @param container {element} parent element in which the form and success message lie
   * @param success {element} element in which the success message lives
   * @returns {boolean} always returns false
   */
  subscribeToEmailList: function (list_id, email, container, success, email_id) {
    if(! this.validateEmail(email)) {
      alert("Please enter a valid email.");

      return false;
    }

    jQuery.ajax({
      type: "POST",
      url: "/email.php",
      data: {
        userid: 74222,
        email: email,
        list_subscription: list_id
      },

      success: function(data) {
        // Reference: http://help.pardot.com/customer/portal/articles/2125981-form-handlers-advanced-topics
        var pardotFormHandler = "https://go.pardot.com/l/232142/2017-01-12/qv?&email=" + email;

        // Send form data to Pardot using an invisible iframe
        jQuery('input[id="' + email_id + '"]').append('<iframe src="' + pardotFormHandler + '" width="1" height="1"></iframe>');

        AsanaHelpers.setCookie("subscribed_email_list_" + list_id, 1, 364);

        jQuery(container).hide();
        jQuery(success).fadeIn();
      },

      error: function(data) {
        console.log('ERROR: Unsuccessful request to Dotmailer. View log below for more information');
        console.log(data);

        Bugsnag.notifyException(data, "Unsuccessful subscription request to Dotmailer");
      }
    });

    return false;
  },

  /**
   * Produces a string containing a json object of which Optimizely (or, in
   * future, other) static site experiments are currently running, mapped to
   * which variant the user is in.
   */
  experimentVariants: function() {
    try {
      var optimizely = window.optimizely;

      if (!optimizely || !("activeExperiments" in optimizely)) return [];

      var activeExperiments = optimizely.activeExperiments;
      var experimentVariants = {};
      activeExperiments.forEach(function (experiment_id_string) {
        var experimentId = parseInt(experiment_id_string, 10);
        var experimentName = optimizely.data.experiments[experimentId].name;
        var variantId = optimizely.variationIdsMap[experimentId][0];
        var variantName = optimizely.data.variations[variantId].name;
        experimentVariants[experimentName] = variantName;
      });

      return JSON.stringify(experimentVariants);
    } catch (e) {
      Bugsnag.notifyException(e, "Error dumping Optimizely experiments.");
    }
  },

  logExperimentVariantsToApp: function() {

    if(!AsanaHelpers.isProduction()) { return; }

    submitData = {};
    submitData.experiments = this.experimentVariants();

    /* We assume there is almost always at least one running experiment so it's not worth optimizing
       not to send when there are none. */
    jQuery.ajax({
      url: AsanaHelpers.appUrl("/-/external_experiments"),
      type: "POST",
      data: submitData,
      timeout: 10000,
      error: function (jqXHR, textStatus, errorThrown) {
        Bugsnag.notifyException(errorThrown, "Failed to log experiments to app (ajax)");
      }
    });
  },

  startsWith: function(str, prefix) {
    return (str.lastIndexOf(prefix, 0) === 0);
  },

  endsWith: function (str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
  },

  /**
   * Load Ethn.io
   * UXR tool that pops up a survey on select pages
   */
  loadEthnio: function() {

    var ethnio_id = false;

    // fixing a bugsnag bug related to some browsers not being able
    // to access the path - TODO: find a better way to do this globally
    if(typeof(window.location.pathname) === "undefined") { return; }

    switch(window.location.pathname) {
      case "/":
      case "/product":
        ethnio_id = 15976;
        break;
    }

    if(AsanaHelpers.startsWith(window.location.pathname, "/guide")) {
      ethnio_id = 45066;
    }

    // prevent ethnio from showing on mobile or IE - (do we want IE?)
    if(ethnio_id && !AsanaHelpers.specialPlatform()) {

      Ethnio = {
        display_screener : true,
        force_display : false,
        debug_mode : false,
        display_interval : 1,
        check_cookies: true,
        fast_start: true  // AlexD changed this
      };

      jQuery.getScript("//ethn.io/" + ethnio_id + ".js");
    }

  }

};

AsanaHelpers.initializeSecurityToken();
AsanaHelpers.redirectGoogleAppMarketplaceClicks();
AsanaHelpers.setGlobalClasses();


/**
 * NO-FOUT FONTS - these fonts are unlikely to have a FOUT
 * this will load any fonts being used on the current page, assuming they are
 * defined in fonts-blocking.css
 */
WebFont.load({
  custom: {
    urls: ["/wp-content/themes/wavelength/dist/css/fonts-blocking.css"]
  }
});

/**
 * Executes immediately after entire DOM is loaded
 */
jQuery(document).ready(function() {

  AsanaHelpers.addSecurityTokenToForms();

  /**
   * FOUT FONTS - these fonts will have unstyled text until the fonts are loaded
   * this also pre-loads all our unused fonts so that they get cached - all of
   * our fonts should be listed here
   */

  WebFont.load({
    events: false,
    classes: false, // do not set classes on global elements - (allow FOUT)
    custom: {
      families: [
        "haptik:n2"
      ],
      urls: ["/wp-content/themes/wavelength/dist/css/fonts-nonblocking.css"]
    }
  });

  /**
   * OTHER MISC THINGS
   *
   */
  jQuery("input").attr("autocomplete", "off");


});


/**
 * Executes after all assets on the page have loaded
 */
jQuery(window).load(function() {

  /**
   * GOOGLE TAG MANAGER (GTM)
   * load this last, always - we think it can block pageload (and we can test
   * this assumption by putting an endless loop in the function below.).
   * dataLayer.push() also causes ajax requests - they should happen AFTER this
   */
  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://t-antenna.asana.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-PQCML3R');

  dataLayer.push({
    "event": "visitor"
  });

  if(AsanaHelpers.getCookie("is_logged_in")) {
    // TODO:GTM - this is slot #1
    dataLayer.push({
      "logged_in": true
    });
  }

  /**
   * SEND OPTIMIZELY INFO TO GTM => GA; ADD A COOKIE THAT WE PASS WITH SIGNUPS
   * this is all in the name of unifying these front end tests with other data
   */
  window.optimizely = window.optimizely || [];
  window.optimizely.push("activateUniversalAnalytics");

  try {
    AsanaHelpers.updateAttributionCookie();
  } catch(e) {
    console.log(e);
    Bugsnag.notifyException(e, "Failed to update attribution cookie.");
  }

  try {
    var activeExperiments = optimizely.activeExperiments;
    activeExperiments.forEach(function (experiment_id_string) {
      var experimentId = parseInt(experiment_id_string, 10);
      var experimentName = optimizely.data.experiments[experimentId].name;
      var variantId = optimizely.variationIdsMap[experimentId][0];
      var variantName = optimizely.data.variations[variantId].name;
      // TODO:GTM - this is slot #4
      dataLayer.push({
        "experimentName": variantName
      });
    });
  } catch(e) {
    Bugsnag.notifyException(e, "Failed to send Optimizely Experiments to GA");
  }

  if("data" in optimizely && "experiments" in optimizely.data){
    try {
      var experiments_json = {};
      for (var e in optimizely.data.experiments) {
        experiments_json[optimizely.data.experiments[e].name]=optimizely.variationNamesMap[e];
      }
      AsanaHelpers.setCookie("asana_experiments", JSON.stringify(experiments_json), 30, true);
    } catch(err){
      Bugsnag.notifyException(err, "Failed to set Optimizely cookie.");
    }

    try {
      AsanaHelpers.logExperimentVariantsToApp();
    } catch(err){
      Bugsnag.notifyException(err, "Failed to log experiments to app (pre-ajax)");
    }
  }

  /**
   * PRELOAD IMAGES - just add them here
   *
   */
  if (document.images) {
    img1 = new Image();
//    img2 = new Image();
//    img3 = new Image();

    img1.src = "//d1gwm4cf8hecp4.cloudfront.net/images/modals/loadingBar_striped.gif";
//    img2.src = "http://domain.tld/path/to/image-002.gif";
//    img3.src = "http://domain.tld/path/to/image-003.gif";
  }

  try {
    // AsanaHelpers.loadEthnio();
  } catch(err){
    Bugsnag.notifyException(err, "Problem loading Ethnio");
  }

});

(function($) {
  /**
   * Wavelength JavaScript Utilities
   */
  WavelengthHelpers = {
    /**
     * getParameterByName()
     *
     * Can be used to determine if a URL parameter currently exists.
     *
     * @param {string} The name of the URL parameter
     * @param {url} The URL that you want to test for (current URL by default)
     * @returns {boolean} Returns value of URL parameter if it exists
     */
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");

      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
      var results = regex.exec(url);

      if (!results) return null;
      if (!results[2]) return '';

      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },


    /**
     * compareUrls()
     *
     * Determine if the current URL matches any in an array of URLs provide.
     *
     * @param {string} URL you want to compare against
     * @param {array} Array of URLs that you wish to compare
     * @returns {boolean} Returns true if current URL and a URL from urlArray match
     */
    compareUrls: function(currentUrl, urlArray) {
      for (var i in urlArray) {
        if (currentUrl == urlArray[i]) {
          return true;
        }
      }
    },


    /**
     * getMobileOperatingSystem()
     *
     * Determine the mobile operating system
     *
     * @returns {string}
     */
    getMobileOperatingSystem: function() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      var iOS = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ];

      while (iOS.length) {
        if (navigator.platform === iOS.pop()) {
          return 'iOS';
        }
      }

      if (userAgent.match( /Android/i )) {
        return 'Android';
      } else {
        return 'unknown';
      }
    },


    /**
     * setMobileBodyClasses()
     *
     * Determine the mobile operating system and set `<body>` classes as appropriate
     *
     * @returns null
     *
     * TODO: This could take a parameter for whatever element you want to add these
     *       classes to. So you can pass `$body` which adds the classes to the cached
     *       `body` element, or perhaps you pass `.component` which allows for a bit
     *       more flexibility.
     */
    setMobileBodyClasses: function() {
      var $body = $('body');

      if (WavelengthHelpers.getMobileOperatingSystem() == "iOS") {
        $body.addClass('device-ios');
      } else if (WavelengthHelpers.getMobileOperatingSystem() == "Android") {
        $body.addClass('device-android');
      }
    },


    /**
     * isOnScreen()
     *
     * Used to determine if an element is currently visible in the viewport.
     * http://upshots.org/javascript/jquery-test-if-element-is-in-viewport-visible-on-screen
     *
     * @param {element} Element to test against
     * @returns {boolean} Returns true if element is in viewport; false if it is not
     */
    isOnScreen: function(el) {
      if (el.length) {
        var viewport = {};
        viewport.top = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();

        var bounds = {};
        bounds.top = el.offset().top;
        bounds.bottom = bounds.top + el.outerHeight();

        // Ensure that elements are displayed if window is reloaded below elements
        // that would otherwise be animated. i.e. no element animates as you scroll up
        if (viewport.top >= bounds.top) {
          return true;
        } else {
          return ((bounds.top <= viewport.bottom) && (bounds.bottom >= viewport.top));
        }
      }
    },


    /**
     * animateVisibleElement()
     *
     * Adds an animation class (ie, modifier) to an element or set of elements
     * once they are in the viewport.
     *
     * @param {array,element} Array of elements or single element
     * @param {element} Animation modifier class to be added
     * @returns null
     */
    animateVisibleElement: function(el, animation) {
      function showElement(el) {
        var visibility = WavelengthHelpers.isOnScreen(el);

        if (visibility == true) {
          el.addClass(animation);
        }
      }

      if (el instanceof Array) {
        for (var i = 0; i < el.length; i++) {
          var $current = $(el[i]);
          showElement($current);
        }
      } else {
        var $current = $(el);
        showElement($current);
      }
    }
  };
})(jQuery);

(function($) {
  /**
   * Caching Global Objects
   */
  $window = $(window);


  /**
   * Optimizely Utilities
   */
  WavelengthOptimizely = {
    /**
     * activeVariations()
     *
     * Return a list of active Optimizely variation IDs
     *
     * @returns {id} Array of IDs as active Optimizely variations
     */
    activeVariations: function() {
      var activeVariations = [];

      // Get state settings from optimizely object
      var state = window['optimizely'].data.state;

      // For each of the active experiments
      for (var i = state.activeExperiments.length - 1; i >= 0; i--) {
        var experimentID = state.activeExperiments[i];
        var variationID = state.variationIdsMap[experimentID];

        if (variationID) { activeVariations.push(variationID[0]); }
      }

      return activeVariations;
    },


    /**
     * getTestID()
     *
     * Return true or false for given Optimizely test ID.
     *
     * @param id {string} ID number as string for test
     *
     * @returns {Boolean}
     */
    getTestID: function(id) {
      if ($.inArray(id, WavelengthOptimizely.activeVariations()) !== -1) {
        return true;
      } else {
        return false;
      }
    },


    /**
     * scrollModal()
     *
     * Display a modal after scrolling a certain distance.
     *
     * @param modal {id} The modal to display
     * @param distance {int} The distance from the top of the screen to show the modal
     *
     * @returns null
     */
    scrollModal: function(modal, distance) {
      if ($window.scrollTop() > distance) {
        AsanaHelpers.showModal(modal);
      }
    },


    /**
     * trackClicks()
     *
     * Simple helper function to track element clicks and push optimizely events.
     *
     * @param el {string} Element for the click handler
     * @param event {string} Name of the optimizely event to track
     *
     * @returns null
     */
    trackClicks: function(el, event) {
      var $el = $(el);

      $el.click(function() {
        window.optimizely.push(["trackEvent", event]);
      });
    }
  };
})(jQuery);

(function($) {
  /**
   * Caching Global Objects
   */
  var $window = $(window);
  var $document = $(document);


  /**
   * Wavelength UI Utilities
   */
  WavelengthUi = {

    /**
     * setupMasonry()
     *
     * This sets up our masonry layout for posts
     *
     * @returns null
     */
    setupMasonry: function() {
      var masonry;
      var masonrySelector = '.issue-column';
      var masonryContainer = document.querySelector('.issues-row--infinite');

      imagesLoaded(masonryContainer, function() {
        masonry = new Masonry(masonryContainer, {
          columnWidth: masonrySelector,
          gutter: 0,
          itemSelector: masonrySelector,
          percentPosition: true,
          transitionDuration: '0.15s'
        });
      });
    },


    /**
     * getReadingProgress()
     *
     * This sets up our reading progress bar for articles.
     *
     * @returns null
     */
    getReadingProgress: function() {
      var getMax = function() {
        // NOTE: We offset 120px to account for fixed elements
        return ($document.height() - $window.height() - 120);
      }

      var getValue = function() {
        return $window.scrollTop();
      }

      // Browser supports progress element
      if ('max' in document.createElement('progress')) {
        var $progressBar = $('progress');

        // Set the Max attr for the first time
        $progressBar.attr({ max: getMax() });

        // On scroll only Value attr needs to be calculated
        $document.on('scroll', function() {
          $progressBar.attr({ value: getValue() });
        });

        // On resize, both Max/Value attr needs to be calculated
        $window.resize(function() {
          $progressBar.attr({ max: getMax(), value: getValue() });
        });
      } else {
        var $progressBar = $('.progress-bar');
        var max = getMax();
        var value;
        var width;

        // Calculate width in percentage
        var getWidth = function() {
          value = getValue();
          width = (value/max) * 120;
          width = width + '%';

          return width;
        }

        var setWidth = function() {
          $progressBar.css({ width: getWidth() });
        }

        $document.on('scroll', setWidth);

        // Need to reset the Max attr
        $window.on('resize', function() {
          max = getMax();
          setWidth();
        });
      }
    },


    /**
     * siteAnimations()
     *
     * @returns null
     */
    siteAnimations: function() {
      var $body = $('body');

      // Homepage animations
      if ($body.hasClass("home")) {
        WavelengthHelpers.animateVisibleElement(
          [
            '.issues-label',
            '.issue-column'
          ], '-animated'
        );
      }

      // Archive and Search animations
      if ($body.hasClass("archive") || $body.hasClass("search")) {
        WavelengthHelpers.animateVisibleElement(
          [
            '.archive-header',
            '.article:nth-child(1)',
            '.article:nth-child(2)',
            '.article:nth-child(3)',
            '.article:nth-child(4)',
            '.article:nth-child(5)',
            '.article:nth-child(6)',
            '.article:nth-child(7)',
            '.article:nth-child(8)',
            '.article:nth-child(9)',
            '.article:nth-child(10)',
            '.issues-label',
            '.issue-column'
          ], '-animated'
        );
      }

      // Article animations
      if ($body.hasClass("single")) {
        WavelengthHelpers.animateVisibleElement(
          [
            '.entry-header',
            '.entry-header + img',
            '.entry-content',
            '.contents',
            '.issues-label',
            '.issue-column'
          ], '-animated'
        );
      }
    },


    /**
     * copyToClipboard()
     *
     * Appends an icon to the social share icons on single posts and allows
     * the user to copy the current post URL to the clipboard.
     *
     * @returns null
     */
    copyToClipboard: function() {
      var url = window.location.href;
      var clip = new Clipboard('.tooltip input');
      var icon = '<li class="essb_item essb_permalink"><a><span class="essb_icon essb_icon_link"><span class="icon icon--link"></span></span><span class="tooltip"><span class="p--label">Copy Link</span><input value="' + url + '" data-clipboard-text="' + url + '"></span></span></li>';
      var success = 'Link Copied! <span class="icon icon--check"></span>';

      if ($('body').hasClass("single") || $('body').hasClass("archive")) {
        $('.essb_links_list').append(icon);

        $('.essb_permalink').on('hover', function() {
          $('.tooltip').toggleClass('is-shown');
        });

        clip.on("success", function() {
          $('.tooltip .p--label').html(success);
        });
      }
    },


    /**
     *
     */
    socialAnalytics: function() {
      var $body = $('body');

      setTimeout(function() {
        if ($body.hasClass('page-template-page-social-shares')) {
          var $shareCount = $('.js-shareCount');
          var shareCount = 0;
          var commentCount = 0;
          var totalPosts = ($shareCount.length - 1);

          $shareCount.each(function(i) {
            count = $('.essb-total-value', this).text();

            shareCount += parseInt(count);

            if (i == totalPosts) {
              $('.js-totalShares').text(shareCount);
            }
          });

          $('.js-commentCount').each(function(i) {
            count = $(this).text();

            commentCount += parseInt(count);

            if (i == totalPosts) {
              $('.js-totalComments').text(commentCount);
            }
          });
        }
      }, 3000);
    }
  };
})(jQuery);



(function($) {
 /**
  * Caching Global Objects
  */
  $window = $(window);
  $document = $(document);


  /**
   * On Window Load
   */
  $window.load(function() {
    // Website animations
    WavelengthUi.siteAnimations();
  });


   /**
   * stackoverflow.com/questions/46155/validate-email-address-in-javascript
   * @param email {string} a test string
   * @returns {boolean} whether or not string is a valid email address
   */
  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }


  /**
   * On Document Ready
   */
  $document.ready(function() {
    var $body = $('body');

    // Set mobile body classes
    WavelengthHelpers.setMobileBodyClasses();

    // Copy to clipboard
    WavelengthUi.copyToClipboard();

    // Social Analytics
    WavelengthUi.socialAnalytics();

    // Page-specific functions
    if ($body.hasClass("home")) {
      WavelengthUi.setupMasonry();
    } else if ($body.hasClass("single")) {
      WavelengthUi.getReadingProgress();
    }


    // Header search
    var $searchIcon = $('.search-icon');
    var $searchForm = $('.siteHeader-search input[type="search"]');

    $searchIcon.on('click', function() {
      $searchForm.focus();
    });

    // Mobile bottom bar
    var $subscriptionButton = $('#subscription button');

    $subscriptionButton.on('click', function() {
      var $mobilebar = $('.mobilebar');

      setTimeout(function() {
        window.location.hash = "close";
      }, 1500);

      if (! $body.hasClass('single')) {
        $mobilebar.hide();
      } else if ($body.hasClass('single')) {
        $mobilebar.find('.button').hide();
      }
    });

    // blog sub form validation

    $result = $("#result"),
    $submit = $("#validate"),
    $emailInput = $("#email");

    function validate() {
      $email = $("#email").val();
    
      if (validateEmail($email)) {
  
        $("#validate").prop( "disabled", false );
        $result.hide();
        
      } else {
        $submit.prop( "disabled", true );
        $result.text("Please enter a valid email");
        $result.css("color", "red");
      }
      return false;
    }
        
    $emailInput.on("blur", validate);
  });


  /**
   * On Window Scroll
   */
  $window.scroll(function() {
    var $body = $('body');
    var currentPosition = $window.scrollTop();

    // Website animations
    WavelengthUi.siteAnimations();

    // Hiding share icons at appropriate time
    if ($body.hasClass("single") || $body.hasClass("archive")) {
      var $otherIssues = $('.otherIssues');
      var $otherIssuesOffset = $otherIssues.offset().top;
      var $socialShares = $('.essb_fixed');

      if (currentPosition >= ($otherIssuesOffset / 1.2)) {
        $socialShares.fadeOut('fast');
      } else {
        $socialShares.fadeIn();
      }
    }

    // Slide-in CTA
    if ($body.hasClass("single") && AsanaHelpers.getCookie('subscribed_email_list_16525685') != 1) {
      var $slidein = $('.slidein');
        targetHeight = $window.height(),
        scrollPos = $document.scrollTop();

      if ((scrollPos >= (targetHeight))) {
        $slidein.addClass('slidein--isShown');
      } else {
        $slidein.removeClass('slidein--isShown');
      }
    }

    // About page
    if ($body.hasClass('page') && ! $body.hasClass('home')) {
      var currentPosition = $window.scrollTop();

      // Second Section
      var $secondSection = $('section:nth-child(2)');
      var secondSectionPosition = $secondSection.offset().top;
      var $secondSectionHeading = $('section:nth-child(2) h2');
      var $secondSectionParagraphFirst = $('section:nth-child(2) p:nth-of-type(1)');
      var $secondSectionParagraphSecond = $('section:nth-child(2) p:nth-of-type(2)');
      var $secondSectionParagraphThird = $('section:nth-child(2) p:nth-of-type(3)');
      var $secondSectionDot = $('section:nth-child(2) .dot');

      if (currentPosition >= (secondSectionPosition / 3.25)) {
        $secondSectionHeading.addClass('text--animateUp');
        $secondSectionParagraphFirst.addClass('text--animateUpFirst');
        $secondSectionParagraphSecond.addClass('text--animateUpSecond');
        $secondSectionParagraphThird.addClass('text--animateUpThird');
      }

      // Third Section
      var $burst = $('.burst');
      var thirdSectionPosition = $('section:nth-child(3)').offset().top;
      var $thirdSectionHeading = $('section:nth-child(3) h2');
      var $thirdSectionParagraphFirst = $('section:nth-child(3) p:nth-of-type(1)');
      var $thirdSectionParagraphSecond = $('section:nth-child(3) p:nth-of-type(2)');
      var $thirdSectionParagraphThird = $('section:nth-child(3) p:nth-of-type(3)');

      if (currentPosition >= (thirdSectionPosition / 1.25)) {
        $thirdSectionHeading.addClass('text--animateUp');
        $thirdSectionParagraphFirst.addClass('text--animateUpFirst');
        $thirdSectionParagraphSecond.addClass('text--animateUpSecond');
        $thirdSectionParagraphThird.addClass('text--animateUpThird');

        setTimeout(function() {
          $burst.addClass('burst--active');
        }, 1500);
      }
    }
  });


  /**
   * On Mobile Touch/Move
   */
  $window.bind('touchmove', function(e) {
    // Mobile bottom bar
    var $mobilebar = $('.mobilebar');
    var lastScrollTop = 0;
    var scrollPos = $(this).scrollTop();

    if (scrollPos > lastScrollTop) {
      setTimeout(function() {
        $mobilebar.addClass('mobilebar-isHidden');
      }, 200);
    } else {
      setTimeout(function() {
        $mobilebar.removeClass('mobilebar-isHidden');
      }, 200);
    }

    lastScrollTop = scrollPos;
  });
})(jQuery);
